import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  File: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
};

/** Autogenerated input type of AcceptTradeinItems */
export type AcceptTradeinItemsInput = {
  /** 承諾するアイテムのUUID一覧 */
  acceptedItemUuids: Array<Scalars['ID']['input']>;
  /** 下取り申請UUID */
  applicationUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcceptTradeinItems. */
export type AcceptTradeinItemsPayload = {
  __typename?: 'AcceptTradeinItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinApplication?: Maybe<TradeinApplication>;
};

/** Autogenerated input type of ActivateBrandUser */
export type ActivateBrandUserInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateBrandUser. */
export type ActivateBrandUserPayload = {
  __typename?: 'ActivateBrandUserPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type AdCost = {
  __typename?: 'AdCost';
  /** キャンペーン名（指定なしは空文字） */
  campaignName: Scalars['String']['output'];
  /** クリック数 */
  clicks: Scalars['Int']['output'];
  /** 広告費用 */
  cost: Scalars['Int']['output'];
  /** 費用の発生日 */
  date: Scalars['ISO8601Date']['output'];
  /** インプレッション数 */
  impressions: Scalars['Int']['output'];
  referrerGroup: ReferrerGroup;
  /** 取得元（manual: CSVアップロード / api: 媒体API連携） */
  source: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type AdCosts = {
  __typename?: 'AdCosts';
  adCosts: Array<AdCost>;
  pagination: Pagination;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AddItem */
export type AddItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingUuid: Scalars['ID']['input'];
  orderUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of AddItem. */
export type AddItemPayload = {
  __typename?: 'AddItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

export type Address = {
  __typename?: 'Address';
  building?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameKana?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fullNameKana?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameKana?: Maybe<Scalars['String']['output']>;
  prefecture: Scalars['String']['output'];
  prefectureI18n: Scalars['String']['output'];
  street: Scalars['String']['output'];
  tel: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressAttributes = {
  building?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
  street: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

/** Autogenerated input type of Address */
export type AddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of Address. */
export type AddressPayload = {
  __typename?: 'AddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

export type AdminCategories = {
  __typename?: 'AdminCategories';
  categories: Array<Category>;
  pagination: Pagination;
};

/** Amazon Pay checkout session information */
export type AmazonPaySessionInfo = {
  __typename?: 'AmazonPaySessionInfo';
  /** Buyer email from Amazon */
  buyerEmail?: Maybe<Scalars['String']['output']>;
  /** Buyer name from Amazon */
  buyerName?: Maybe<Scalars['String']['output']>;
  /** Checkout session ID */
  checkoutSessionId: Scalars['String']['output'];
  /** Payment method description (e.g., "Visa ****1234") */
  paymentDescriptor?: Maybe<Scalars['String']['output']>;
  /** Session status */
  status?: Maybe<Scalars['String']['output']>;
};

export type AntiqueLedger = {
  __typename?: 'AntiqueLedger';
  entries: Array<AntiqueLedgerEntry>;
  pagination: Pagination;
  totalCount: Scalars['Int']['output'];
};

export type AntiqueLedgerEntry = {
  __typename?: 'AntiqueLedgerEntry';
  inventoryCode: Scalars['String']['output'];
  inventoryId: Scalars['ID']['output'];
  receiving: AntiqueLedgerReceiving;
  selling?: Maybe<AntiqueLedgerSelling>;
};

export type AntiqueLedgerFeature = {
  __typename?: 'AntiqueLedgerFeature';
  color?: Maybe<Scalars['String']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  productNumber?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type AntiqueLedgerReceiving = {
  __typename?: 'AntiqueLedgerReceiving';
  address?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  classification: Scalars['String']['output'];
  feature: AntiqueLedgerFeature;
  identityVerification?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  transactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AntiqueLedgerSearchAttributes = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  receivedFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  receivedTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

export type AntiqueLedgerSelling = {
  __typename?: 'AntiqueLedgerSelling';
  address?: Maybe<Scalars['String']['output']>;
  classification: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  transactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AssetImage = {
  __typename?: 'AssetImage';
  id: Scalars['ID']['output'];
  keyName: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Autogenerated input type of AssignBrandUserToStore */
export type AssignBrandUserToStoreInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  brandUserUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  storeUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignBrandUserToStore. */
export type AssignBrandUserToStorePayload = {
  __typename?: 'AssignBrandUserToStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  storeAssignment?: Maybe<StoreAssignment>;
};

export type Brand = {
  __typename?: 'Brand';
  cartReminderSetting?: Maybe<CartReminderSetting>;
  conditions?: Maybe<Array<Condition>>;
  email?: Maybe<Scalars['String']['output']>;
  emailSettings?: Maybe<Array<BrandEmailSetting>>;
  ga4PropertyId?: Maybe<Scalars['String']['output']>;
  googleMerchantAccountId?: Maybe<Scalars['String']['output']>;
  googleMerchantDataSourceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  metaFeedEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationEmails?: Maybe<Array<Scalars['String']['output']>>;
  onlineTradeinApprovalEnabled: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  partnerEnabled: Scalars['Boolean']['output'];
  partnerInventoryWorkflow?: Maybe<PartnerInventoryWorkflow>;
  priceRoundingDigit: Scalars['Int']['output'];
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shopifyConnected: Scalars['Boolean']['output'];
  shopifyConnectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shopifyShopId?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  tradeInConditions?: Maybe<Array<Condition>>;
  uuid: Scalars['ID']['output'];
};

/** Autogenerated input type of BrandAdminBulkUpdateInventoryStatus */
export type BrandAdminBulkUpdateInventoryStatusInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  uuids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BrandAdminBulkUpdateInventoryStatus. */
export type BrandAdminBulkUpdateInventoryStatusPayload = {
  __typename?: 'BrandAdminBulkUpdateInventoryStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventories?: Maybe<Array<Inventory>>;
  updatedCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BrandAdminCreateInventory */
export type BrandAdminCreateInventoryInput = {
  attributes: InventoryAttributes;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BrandAdminCreateInventory. */
export type BrandAdminCreateInventoryPayload = {
  __typename?: 'BrandAdminCreateInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
};

/** Autogenerated input type of BrandAdminReceiveInventories */
export type BrandAdminReceiveInventoriesInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BrandAdminReceiveInventories. */
export type BrandAdminReceiveInventoriesPayload = {
  __typename?: 'BrandAdminReceiveInventoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventories?: Maybe<Array<Inventory>>;
  receivedCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BrandAdminUpdateInventory */
export type BrandAdminUpdateInventoryInput = {
  attributes: InventoryAttributes;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of BrandAdminUpdateInventory. */
export type BrandAdminUpdateInventoryPayload = {
  __typename?: 'BrandAdminUpdateInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
};

/** Autogenerated input type of BrandAdminUpdateTradeinItem */
export type BrandAdminUpdateTradeinItemInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 下取り可否（possible / not_possible） */
  eligibility?: InputMaybe<Scalars['String']['input']>;
  /** 特記事項 */
  note?: InputMaybe<Scalars['String']['input']>;
  /** TradeinItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of BrandAdminUpdateTradeinItem. */
export type BrandAdminUpdateTradeinItemPayload = {
  __typename?: 'BrandAdminUpdateTradeinItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinItem?: Maybe<TradeinItem>;
};

/** Autogenerated input type of BrandAdminUpdateTradeinLineItem */
export type BrandAdminUpdateTradeinLineItemInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 下取り可否（possible / not_possible） */
  eligibility?: InputMaybe<Scalars['String']['input']>;
  /** 特記事項 */
  note?: InputMaybe<Scalars['String']['input']>;
  /** 返品発送日 */
  returnedShippedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** 返品追跡番号 */
  returnedTrackingCode?: InputMaybe<Scalars['String']['input']>;
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of BrandAdminUpdateTradeinLineItem. */
export type BrandAdminUpdateTradeinLineItemPayload = {
  __typename?: 'BrandAdminUpdateTradeinLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

export type BrandAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  ga4PropertyId?: InputMaybe<Scalars['String']['input']>;
  googleMerchantAccountId?: InputMaybe<Scalars['String']['input']>;
  googleMerchantDataSourceId?: InputMaybe<Scalars['String']['input']>;
  metaFeedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineTradeinApprovalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  priceRoundingDigit?: InputMaybe<Scalars['Int']['input']>;
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  shopifyShopId?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type BrandEmailSetting = {
  __typename?: 'BrandEmailSetting';
  emailType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  recipientEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandEmailSettingInput = {
  emailType: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrandUser = {
  __typename?: 'BrandUser';
  brand: Brand;
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storeAssignments: Array<StoreAssignment>;
  stores: Array<Store>;
  tel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type BrandUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUsers = {
  __typename?: 'BrandUsers';
  brandUsers: Array<BrandUser>;
  pagination: Pagination;
};

export type Brands = {
  __typename?: 'Brands';
  brands: Array<Brand>;
  pagination: Pagination;
};

export type Campaign = {
  __typename?: 'Campaign';
  brand: Brand;
  brandId: Scalars['ID']['output'];
  campaignType: Scalars['String']['output'];
  campaignTypeI18n: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  discountType: Scalars['String']['output'];
  discountTypeI18n: Scalars['String']['output'];
  discountValue: Scalars['Int']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  statusI18n: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CampaignAttributes = {
  brandId: Scalars['ID']['input'];
  campaignType: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  discountType: Scalars['String']['input'];
  discountValue: Scalars['Int']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated input type of Campaign */
export type CampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  orderUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of Campaign. */
export type CampaignPayload = {
  __typename?: 'CampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

export type Campaigns = {
  __typename?: 'Campaigns';
  campaigns: Array<Campaign>;
  pagination: Pagination;
};

export type CartReminderSetting = {
  __typename?: 'CartReminderSetting';
  firstDelayDays: Scalars['Int']['output'];
  firstDelayHours: Scalars['Int']['output'];
  firstDelayUnit: FirstDelayUnit;
  firstDelayUnitI18n: Scalars['String']['output'];
  followupCount: Scalars['Int']['output'];
  followupIntervalDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  sendHour: Scalars['Int']['output'];
};

export type CartReminderSettingInput = {
  firstDelayDays: Scalars['Int']['input'];
  firstDelayHours?: InputMaybe<Scalars['Int']['input']>;
  firstDelayUnit?: InputMaybe<FirstDelayUnit>;
  followupCount: Scalars['Int']['input'];
  followupIntervalDays: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  sendHour: Scalars['Int']['input'];
};

export type Category = {
  __typename?: 'Category';
  brand: Brand;
  id: Scalars['ID']['output'];
  listings?: Maybe<Array<Listing>>;
  listingsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  productMasters?: Maybe<Array<ProductMaster>>;
  productMastersCount: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type CategoryAttributes = {
  brandId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated input type of ChangeEmail */
export type ChangeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeEmail. */
export type ChangeEmailPayload = {
  __typename?: 'ChangeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type ChangePassword = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ChangePassword;
};

/** Autogenerated return type of ChangePassword. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ClearTabletDisplay */
export type ClearTabletDisplayInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** タブレットUUID */
  tabletUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of ClearTabletDisplay. */
export type ClearTabletDisplayPayload = {
  __typename?: 'ClearTabletDisplayPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Color = {
  __typename?: 'Color';
  code?: Maybe<Scalars['String']['output']>;
  colorImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ColorAttributes = {
  code?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Condition = {
  __typename?: 'Condition';
  brand?: Maybe<Brand>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  resaleRate?: Maybe<Scalars['Int']['output']>;
  showInTradeIn?: Maybe<Scalars['Boolean']['output']>;
  tradeInRate?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ConditionAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resaleRate?: InputMaybe<Scalars['Int']['input']>;
  showInTradeIn?: InputMaybe<Scalars['Boolean']['input']>;
  tradeInRate?: InputMaybe<Scalars['Int']['input']>;
};

export type Conditions = {
  __typename?: 'Conditions';
  conditions: Array<Condition>;
  pagination: Pagination;
};

/** Autogenerated input type of Confirm */
export type ConfirmInput = {
  amazonCheckoutSessionId?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<OrderAttributionAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
  paymentAttributes?: InputMaybe<PaymentAttributes>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  shippingAddressAttributes: ShippingAddressAttributes;
};

/** Autogenerated return type of Confirm. */
export type ConfirmPayload = {
  __typename?: 'ConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  brand: Brand;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type ContactAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSearch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Contacts = {
  __typename?: 'Contacts';
  contacts: Array<Contact>;
  pagination: Pagination;
};

/** Autogenerated input type of CreateAddress */
export type CreateAddressInput = {
  attributes: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAddress. */
export type CreateAddressPayload = {
  __typename?: 'CreateAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBrandImage */
export type CreateBrandImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['File']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBrandImage. */
export type CreateBrandImagePayload = {
  __typename?: 'CreateBrandImagePayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBrand */
export type CreateBrandInput = {
  attributes: BrandAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBrand. */
export type CreateBrandPayload = {
  __typename?: 'CreateBrandPayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBrandUser */
export type CreateBrandUserInput = {
  attributes: BrandUserInput;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  storeAssignments?: InputMaybe<Array<StoreAssignmentInput>>;
};

/** Autogenerated return type of CreateBrandUser. */
export type CreateBrandUserPayload = {
  __typename?: 'CreateBrandUserPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCampaign */
export type CreateCampaignInput = {
  attributes: CampaignAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCampaign. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCategory */
export type CreateCategoryInput = {
  attribute: CategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCategory. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCheckoutPayload */
export type CreateCheckoutPayloadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCheckoutPayload. */
export type CreateCheckoutPayloadPayload = {
  __typename?: 'CreateCheckoutPayloadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  payloadJson?: Maybe<Scalars['String']['output']>;
  publicKeyId?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCondition */
export type CreateConditionInput = {
  attributes: ConditionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCondition. */
export type CreateConditionPayload = {
  __typename?: 'CreateConditionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContact */
export type CreateContactInput = {
  attributes: ContactAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateContact. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateEventReservation */
export type CreateEventReservationInput = {
  attributes: EventReservationInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEventReservation. */
export type CreateEventReservationPayload = {
  __typename?: 'CreateEventReservationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventReservation?: Maybe<EventReservation>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateInventory */
export type CreateInventoryInput = {
  attributes: InventoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInventory. */
export type CreateInventoryPayload = {
  __typename?: 'CreateInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
};

/** Autogenerated input type of CreateLike */
export type CreateLikeInput = {
  attributes: LikeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLike. */
export type CreateLikePayload = {
  __typename?: 'CreateLikePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  like?: Maybe<Like>;
};

/** Autogenerated input type of CreateListingFromInventory */
export type CreateListingFromInventoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateListingFromInventory. */
export type CreateListingFromInventoryPayload = {
  __typename?: 'CreateListingFromInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of CreateListingImage */
export type CreateListingImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['File']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateListingImage. */
export type CreateListingImagePayload = {
  __typename?: 'CreateListingImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of CreateListing */
export type CreateListingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateListing. */
export type CreateListingPayload = {
  __typename?: 'CreateListingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of CreateNotification */
export type CreateNotificationInput = {
  attributes: NotificationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNotification. */
export type CreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
};

export type CreateOrderAttributes = {
  channel: Scalars['String']['input'];
  paymentStatus: Scalars['String']['input'];
  shippingFee: Scalars['Int']['input'];
  shippingStatus: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated input type of CreateOrder */
export type CreateOrderInput = {
  attributes: CreateOrderAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateOrder. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of CreateProductImage */
export type CreateProductImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['File']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProductImage. */
export type CreateProductImagePayload = {
  __typename?: 'CreateProductImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of CreateProduct */
export type CreateProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  product: ProductAttributes;
  productMaster: ProductMasterAttributes;
};

/** Autogenerated input type of CreateProductMaster */
export type CreateProductMasterInput = {
  attributes: ProductMasterAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateProductMaster. */
export type CreateProductMasterPayload = {
  __typename?: 'CreateProductMasterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  productMaster?: Maybe<ProductMaster>;
};

/** Autogenerated return type of CreateProduct. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of CreateProductVariation */
export type CreateProductVariationInput = {
  attributes: ProductAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productMasterUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProductVariation. */
export type CreateProductVariationPayload = {
  __typename?: 'CreateProductVariationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of CreateReferrerGroup */
export type CreateReferrerGroupInput = {
  attributes: ReferrerGroupAttributes;
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateReferrerGroupMapping */
export type CreateReferrerGroupMappingInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referrerGroupUuid: Scalars['ID']['input'];
  sourceMedium: Scalars['String']['input'];
};

/** Autogenerated return type of CreateReferrerGroupMapping. */
export type CreateReferrerGroupMappingPayload = {
  __typename?: 'CreateReferrerGroupMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  referrerGroupMapping?: Maybe<ReferrerGroupMapping>;
};

/** Autogenerated return type of CreateReferrerGroup. */
export type CreateReferrerGroupPayload = {
  __typename?: 'CreateReferrerGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  referrerGroup?: Maybe<ReferrerGroup>;
};

/** Autogenerated input type of CreateSize */
export type CreateSizeInput = {
  attribute: SizeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSize. */
export type CreateSizePayload = {
  __typename?: 'CreateSizePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Size>;
};

/** Autogenerated input type of CreateStore */
export type CreateStoreInput = {
  attributes: StoreInput;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateStore. */
export type CreateStorePayload = {
  __typename?: 'CreateStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Store>;
};

/** Autogenerated input type of CreateTradeinApplication */
export type CreateTradeinApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 下取りアイテム一覧 */
  items: Array<TradeinItemInput>;
  /** 下取り受付UUID */
  tradeinReceptionUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTradeinApplication. */
export type CreateTradeinApplicationPayload = {
  __typename?: 'CreateTradeinApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinApplication?: Maybe<TradeinApplication>;
};

/** Autogenerated input type of CreateTradein */
export type CreateTradeinInput = {
  attributes: TradeinAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 下取りアイテム（Arc'teryx用） */
  items?: InputMaybe<Array<TradeinLineItemInput>>;
  skipEmail?: InputMaybe<Scalars['Boolean']['input']>;
  subdomain: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTradein. */
export type CreateTradeinPayload = {
  __typename?: 'CreateTradeinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  tradein?: Maybe<Tradein>;
};

/** Autogenerated input type of CreateTradeinPickup */
export type CreateTradeinPickupInput = {
  brandId: Scalars['ID']['input'];
  building?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  packageCount: Scalars['Int']['input'];
  pickupDate: Scalars['ISO8601Date']['input'];
  pickupTimeFrom: Scalars['Int']['input'];
  pickupTimeTo: Scalars['Int']['input'];
  prefecture: Scalars['Int']['input'];
  street: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  tradeinUuid?: InputMaybe<Scalars['ID']['input']>;
  zip: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTradeinPickup. */
export type CreateTradeinPickupPayload = {
  __typename?: 'CreateTradeinPickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinPickup?: Maybe<TradeinPickup>;
};

/** Autogenerated input type of CreateTradeinReception */
export type CreateTradeinReceptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  storeUuid: Scalars['String']['input'];
  tel: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTradeinReception. */
export type CreateTradeinReceptionPayload = {
  __typename?: 'CreateTradeinReceptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinReception?: Maybe<TradeinReception>;
};

/** Autogenerated input type of DeactivateBrandUser */
export type DeactivateBrandUserInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateBrandUser. */
export type DeactivateBrandUserPayload = {
  __typename?: 'DeactivateBrandUserPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteAddress */
export type DeleteAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAddress. */
export type DeleteAddressPayload = {
  __typename?: 'DeleteAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteBrandImage */
export type DeleteBrandImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteBrandImage. */
export type DeleteBrandImagePayload = {
  __typename?: 'DeleteBrandImagePayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteCategory */
export type DeleteCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCategory. */
export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteLike */
export type DeleteLikeInput = {
  attributes: LikeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteLike. */
export type DeleteLikePayload = {
  __typename?: 'DeleteLikePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  like?: Maybe<Like>;
};

/** Autogenerated input type of DeleteListingImage */
export type DeleteListingImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteListingImage. */
export type DeleteListingImagePayload = {
  __typename?: 'DeleteListingImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of DeleteListing */
export type DeleteListingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteListing. */
export type DeleteListingPayload = {
  __typename?: 'DeleteListingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePayment */
export type DeletePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeletePayment. */
export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of DeleteProductImage */
export type DeleteProductImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProductImage. */
export type DeleteProductImagePayload = {
  __typename?: 'DeleteProductImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of DeleteReferrerGroup */
export type DeleteReferrerGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteReferrerGroupMapping */
export type DeleteReferrerGroupMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReferrerGroupMapping. */
export type DeleteReferrerGroupMappingPayload = {
  __typename?: 'DeleteReferrerGroupMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteReferrerGroup. */
export type DeleteReferrerGroupPayload = {
  __typename?: 'DeleteReferrerGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteStore */
export type DeleteStoreInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteStore. */
export type DeleteStorePayload = {
  __typename?: 'DeleteStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTablet */
export type DeleteTabletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTablet. */
export type DeleteTabletPayload = {
  __typename?: 'DeleteTabletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTradeinAsset */
export type DeleteTradeinAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 本人確認書類・顔写真（TradeinAsset）UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTradeinAsset. */
export type DeleteTradeinAssetPayload = {
  __typename?: 'DeleteTradeinAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTradeinVerificationAssets */
export type DeleteTradeinVerificationAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** オンライン買取（Tradein）UUID */
  tradeinUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTradeinVerificationAssets. */
export type DeleteTradeinVerificationAssetsPayload = {
  __typename?: 'DeleteTradeinVerificationAssetsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailChangeConfirmation */
export type EmailChangeConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of EmailChangeConfirmation. */
export type EmailChangeConfirmationPayload = {
  __typename?: 'EmailChangeConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type EventReservation = {
  __typename?: 'EventReservation';
  attendeeCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  lastNameKana?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reservedDate: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type EventReservationInput = {
  attendeeCount: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana?: InputMaybe<Scalars['String']['input']>;
  itemCount: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reservedDate: Scalars['DateTime']['input'];
};

/** Autogenerated input type of ExportListingsCsv */
export type ExportListingsCsvInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportListingsCsv. */
export type ExportListingsCsvPayload = {
  __typename?: 'ExportListingsCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Autogenerated input type of ExportOrdersCsv */
export type ExportOrdersCsvInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  orderDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  shippedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shippedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  shippingStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportOrdersCsv. */
export type ExportOrdersCsvPayload = {
  __typename?: 'ExportOrdersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Autogenerated input type of ExportProductMastersCsv */
export type ExportProductMastersCsvInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportProductMastersCsv. */
export type ExportProductMastersCsvPayload = {
  __typename?: 'ExportProductMastersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Autogenerated input type of ExportProductsCsvAdmin */
export type ExportProductsCsvAdminInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  productMasterName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportProductsCsvAdmin. */
export type ExportProductsCsvAdminPayload = {
  __typename?: 'ExportProductsCsvAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Autogenerated input type of ExportProductsCsv */
export type ExportProductsCsvInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hasListings?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportProductsCsv. */
export type ExportProductsCsvPayload = {
  __typename?: 'ExportProductsCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

/** Autogenerated input type of ExportUsersCsv */
export type ExportUsersCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  search: UserSearchInput;
};

/** Autogenerated return type of ExportUsersCsv. */
export type ExportUsersCsvPayload = {
  __typename?: 'ExportUsersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
};

/** Autogenerated input type of ExportWarrantyCsv */
export type ExportWarrantyCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of ExportWarrantyCsv. */
export type ExportWarrantyCsvPayload = {
  __typename?: 'ExportWarrantyCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csvData: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

export type ExternalMembership = {
  __typename?: 'ExternalMembership';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of FetchGoogleMerchantStatus */
export type FetchGoogleMerchantStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of FetchGoogleMerchantStatus. */
export type FetchGoogleMerchantStatusPayload = {
  __typename?: 'FetchGoogleMerchantStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** カート放棄リマインド1通目の遅延単位 */
export enum FirstDelayUnit {
  /** 日 */
  Day = 'DAY',
  /** 時間 */
  Hour = 'HOUR'
}

export type Gender = {
  __typename?: 'Gender';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateAuthUrl */
export type GenerateAuthUrlInput = {
  /** ブランドUUID（店舗を持たないブランド） */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** フロントエンドベースURL（認証後のリダイレクト先） */
  frontendBaseUrl: Scalars['String']['input'];
  /** 認証後に戻るパス（店舗が無い場合。既定は /） */
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  /** OAuthコールバックURL */
  redirectUri: Scalars['String']['input'];
  /** サイレント認証（prompt=none）を使用するか */
  silent?: InputMaybe<Scalars['Boolean']['input']>;
  /** 店舗UUID（店頭フロー） */
  storeUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of GenerateAuthUrl. */
export type GenerateAuthUrlPayload = {
  __typename?: 'GenerateAuthUrlPayload';
  /** Shopify認証URL */
  authUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** CSRF防止用state */
  state?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GeneratePresignedUrl */
export type GeneratePresignedUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
};

/** Autogenerated return type of GeneratePresignedUrl. */
export type GeneratePresignedUrlPayload = {
  __typename?: 'GeneratePresignedUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  keyName?: Maybe<Scalars['String']['output']>;
  presignUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GuestCheckout */
export type GuestCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
};

/** Autogenerated return type of GuestCheckout. */
export type GuestCheckoutPayload = {
  __typename?: 'GuestCheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of GuestConfirm */
export type GuestConfirmInput = {
  amazonCheckoutSessionId?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<OrderAttributionAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guestEmail: Scalars['String']['input'];
  guestTel: Scalars['String']['input'];
  orderUuid: Scalars['ID']['input'];
  paymentAttributes?: InputMaybe<PaymentAttributes>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  shippingAddressAttributes: ShippingAddressAttributes;
};

/** Autogenerated return type of GuestConfirm. */
export type GuestConfirmPayload = {
  __typename?: 'GuestConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ImportAdCosts */
export type ImportAdCostsInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csvData: Scalars['String']['input'];
};

/** Autogenerated return type of ImportAdCosts. */
export type ImportAdCostsPayload = {
  __typename?: 'ImportAdCostsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ImportProductMastersCsv */
export type ImportProductMastersCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csvData: Scalars['String']['input'];
};

/** Autogenerated return type of ImportProductMastersCsv. */
export type ImportProductMastersCsvPayload = {
  __typename?: 'ImportProductMastersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ImportProductsCsv */
export type ImportProductsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csvData: Scalars['String']['input'];
};

/** Autogenerated return type of ImportProductsCsv. */
export type ImportProductsCsvPayload = {
  __typename?: 'ImportProductsCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
};

export type Inventories = {
  __typename?: 'Inventories';
  inventories: Array<Inventory>;
  pagination: Pagination;
  totalCount: Scalars['Int']['output'];
};

export type Inventory = {
  __typename?: 'Inventory';
  brand: Brand;
  color?: Maybe<Color>;
  id: Scalars['ID']['output'];
  inventoryCode: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  itemTypeI18n: Scalars['String']['output'];
  listing?: Maybe<Listing>;
  maintenancePolicy: Scalars['String']['output'];
  maintenancePolicyI18n: Scalars['String']['output'];
  product: Product;
  recognizedAt: Scalars['ISO8601Date']['output'];
  size?: Maybe<Size>;
  status: Scalars['String']['output'];
  statusI18n: Scalars['String']['output'];
  storageLocation: StorageLocation;
  store?: Maybe<Store>;
  tradein?: Maybe<Tradein>;
  tradeinItem?: Maybe<TradeinItem>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
  uuid: Scalars['ID']['output'];
};

export type InventoryAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  colorId?: InputMaybe<Scalars['ID']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  maintenancePolicy?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  recognizedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  sizeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storageLocationId?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  tradeinId?: InputMaybe<Scalars['ID']['input']>;
};

export type InventorySearchAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storageLocationId?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of IssueShopifyDiscountCode */
export type IssueShopifyDiscountCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** オンライン買取（Tradein）UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of IssueShopifyDiscountCode. */
export type IssueShopifyDiscountCodePayload = {
  __typename?: 'IssueShopifyDiscountCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountCodes?: Maybe<Array<TradeinDiscountCode>>;
  error?: Maybe<Scalars['String']['output']>;
  tradein?: Maybe<Tradein>;
};

export type Item = {
  __typename?: 'Item';
  id: Scalars['ID']['output'];
  listing: Listing;
  listingId: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type Like = {
  __typename?: 'Like';
  brand?: Maybe<Brand>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  listing?: Maybe<Listing>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type LikeAttributes = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
};

export type Listing = {
  __typename?: 'Listing';
  availableConditions?: Maybe<Array<Condition>>;
  brand: Brand;
  brandId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  conditionId?: Maybe<Scalars['ID']['output']>;
  conditionText?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  googleMerchantApprovalStatus?: Maybe<Scalars['String']['output']>;
  googleMerchantError?: Maybe<Scalars['String']['output']>;
  googleMerchantLastStatusCheckAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  googleMerchantSyncStatus?: Maybe<Scalars['String']['output']>;
  googleMerchantSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Image>>;
  isLiked: Scalars['Boolean']['output'];
  isSoldOut: Scalars['Boolean']['output'];
  itemType: Scalars['String']['output'];
  itemTypeI18n: Scalars['String']['output'];
  janCode?: Maybe<Scalars['String']['output']>;
  likeCount?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  product: Product;
  productId: Scalars['ID']['output'];
  repairMethod?: Maybe<Scalars['String']['output']>;
  repairMethodI18n?: Maybe<Scalars['String']['output']>;
  sellerId: Scalars['ID']['output'];
  size?: Maybe<Size>;
  sizeId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  statusI18n: Scalars['String']['output'];
  usedItemId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ListingAttributes = {
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  conditionText?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  janCode?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  repairMethod?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  sizeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  usedItemId?: InputMaybe<Scalars['String']['input']>;
};

export type ListingSearch = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  janCode?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productMasterCode?: InputMaybe<Scalars['String']['input']>;
  productMasterName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  usedItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type Listings = {
  __typename?: 'Listings';
  listings: Array<Listing>;
  pagination: Pagination;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of LoginWithStorefront */
export type LoginWithStorefrontInput = {
  /** ブランドUUID */
  brandId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Shopify顧客のメールアドレス */
  email: Scalars['String']['input'];
  /** Shopify顧客のパスワード */
  password: Scalars['String']['input'];
};

/** Autogenerated return type of LoginWithStorefront. */
export type LoginWithStorefrontPayload = {
  __typename?: 'LoginWithStorefrontPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTradeinItems?: Maybe<AcceptTradeinItemsPayload>;
  activateBrandUser: ActivateBrandUserPayload;
  addItem: AddItemPayload;
  address: AddressPayload;
  assignBrandUserToStore: AssignBrandUserToStorePayload;
  brandAdminBulkUpdateInventoryStatus: BrandAdminBulkUpdateInventoryStatusPayload;
  brandAdminCreateInventory: BrandAdminCreateInventoryPayload;
  brandAdminReceiveInventories: BrandAdminReceiveInventoriesPayload;
  brandAdminUpdateInventory: BrandAdminUpdateInventoryPayload;
  brandAdminUpdateTradeinItem: BrandAdminUpdateTradeinItemPayload;
  brandAdminUpdateTradeinLineItem: BrandAdminUpdateTradeinLineItemPayload;
  campaign: CampaignPayload;
  changeEmail: ChangeEmailPayload;
  changePassword: ChangePasswordPayload;
  clearTabletDisplay: ClearTabletDisplayPayload;
  confirm: ConfirmPayload;
  createAddress: CreateAddressPayload;
  createAmazonPayCheckoutPayload: CreateCheckoutPayloadPayload;
  createBrand: CreateBrandPayload;
  createBrandImage: CreateBrandImagePayload;
  createBrandUser: CreateBrandUserPayload;
  createCampaign: CreateCampaignPayload;
  createCategory?: Maybe<CreateCategoryPayload>;
  createCondition: CreateConditionPayload;
  createContact: CreateContactPayload;
  createEventReservation: CreateEventReservationPayload;
  createInventory: CreateInventoryPayload;
  createLike: CreateLikePayload;
  createListing: CreateListingPayload;
  createListingFromInventory: CreateListingFromInventoryPayload;
  createListingImage: CreateListingImagePayload;
  createNotification: CreateNotificationPayload;
  createOrder: CreateOrderPayload;
  createProduct: CreateProductPayload;
  createProductImage: CreateProductImagePayload;
  createProductMaster: CreateProductMasterPayload;
  createProductVariation: CreateProductVariationPayload;
  createReferrerGroup?: Maybe<CreateReferrerGroupPayload>;
  createReferrerGroupMapping?: Maybe<CreateReferrerGroupMappingPayload>;
  createSize?: Maybe<CreateSizePayload>;
  createStore: CreateStorePayload;
  createTradein: CreateTradeinPayload;
  createTradeinApplication: CreateTradeinApplicationPayload;
  createTradeinPickup: CreateTradeinPickupPayload;
  createTradeinReception: CreateTradeinReceptionPayload;
  deactivateBrandUser: DeactivateBrandUserPayload;
  deleteAddress: DeleteAddressPayload;
  deleteBrandImage: DeleteBrandImagePayload;
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  deleteLike: DeleteLikePayload;
  deleteListing: DeleteListingPayload;
  deleteListingImage: DeleteListingImagePayload;
  deletePayment: DeletePaymentPayload;
  deleteProductImage: DeleteProductImagePayload;
  deleteReferrerGroup?: Maybe<DeleteReferrerGroupPayload>;
  deleteReferrerGroupMapping?: Maybe<DeleteReferrerGroupMappingPayload>;
  deleteStore: DeleteStorePayload;
  deleteTablet: DeleteTabletPayload;
  deleteTradeinAsset?: Maybe<DeleteTradeinAssetPayload>;
  deleteTradeinVerificationAssets?: Maybe<DeleteTradeinVerificationAssetsPayload>;
  emailChangeConfirmation: EmailChangeConfirmationPayload;
  exportListingsCsv: ExportListingsCsvPayload;
  exportOrdersCsv: ExportOrdersCsvPayload;
  exportProductMastersCsv: ExportProductMastersCsvPayload;
  exportProductsCsv: ExportProductsCsvPayload;
  exportProductsCsvAdmin: ExportProductsCsvAdminPayload;
  exportUsersCsv?: Maybe<ExportUsersCsvPayload>;
  exportWarrantyCsv: ExportWarrantyCsvPayload;
  fetchGoogleMerchantStatus: FetchGoogleMerchantStatusPayload;
  generatePresignedUrl: GeneratePresignedUrlPayload;
  /** Shopify Customer Account API認証URLを生成する */
  generateShopifyAuthUrl: GenerateAuthUrlPayload;
  guestCheckout: GuestCheckoutPayload;
  guestConfirm: GuestConfirmPayload;
  importAdCosts?: Maybe<ImportAdCostsPayload>;
  importProductMastersCsv: ImportProductMastersCsvPayload;
  importProductsCsv: ImportProductsCsvPayload;
  issueShopifyDiscountCode?: Maybe<IssueShopifyDiscountCodePayload>;
  /** Shopify Storefront API (legacy customer accounts) によるメール/パスワード認証 */
  loginWithShopifyStorefront: LoginWithStorefrontPayload;
  order: OrderPayload;
  registerInventoryFromTradeinLineItem: RegisterInventoryFromTradeinLineItemPayload;
  registerTablet: RegisterTabletPayload;
  removeItem: RemoveItemPayload;
  resendConfirmation: ResendConfirmationPayload;
  resetBrandUserPassword: ResetBrandUserPasswordPayload;
  resetPassword: ResetPasswordPayload;
  sendSmsNotification: SendSmsNotificationPayload;
  signin: SigninPayload;
  signinBrandAdmin: SigninBrandAdminPayload;
  signinKish: SigninKishPayload;
  signout: SignoutPayload;
  signup: SignupPayload;
  signupConfirmation: SignupConfirmationPayload;
  subscribeNewsletter: SubscribeNewsletterPayload;
  syncListingToGoogleMerchant: SyncListingToGoogleMerchantPayload;
  triggerTabletDisplay: TriggerTabletDisplayPayload;
  unassignBrandUserFromStore: UnassignBrandUserFromStorePayload;
  unsubscribeCartReminderByToken: UnsubscribeCartReminderByTokenPayload;
  unsubscribeNewsletter: UnsubscribeNewsletterPayload;
  unsubscribeNewsletterByToken: UnsubscribeNewsletterByTokenPayload;
  updateAddress: UpdateAddressPayload;
  updateBrand: UpdateBrandPayload;
  updateBrandEmailSettings: UpdateBrandEmailSettingsPayload;
  updateBrandImage: UpdateBrandImagePayload;
  updateBrandUser: UpdateBrandUserPayload;
  updateCampaign: UpdateCampaignPayload;
  updateCartReminderSetting: UpdateCartReminderSettingPayload;
  updateCartReminderSubscription: UpdateCartReminderSubscriptionPayload;
  updateCategory: UpdateCategoryPayload;
  updateCategoryPositions?: Maybe<UpdateCategoryPositionsPayload>;
  updateColor: UpdateColorPayload;
  updateCondition: UpdateConditionPayload;
  updateConditionPositions?: Maybe<UpdateConditionPositionsPayload>;
  updateInventory: UpdateInventoryPayload;
  updateListing: UpdateListingPayload;
  updateListingImage: UpdateListingImagePayload;
  updateListingImagePosition: UpdateListingImagePositionPayload;
  updateOrder: UpdateOrderPayload;
  updatePassword: UpdatePasswordPayload;
  updatePayment: UpdatePaymentPayload;
  updatePrimaryAddress: UpdatePrimaryAddressPayload;
  updateProduct: UpdateProductPayload;
  updateProductImage: UpdateProductImagePayload;
  updateProductImagePosition: UpdateProductImagePositionPayload;
  updateProductMaster: UpdateProductMasterPayload;
  updateProfile: UpdateProfilePayload;
  updateReferrerGroup?: Maybe<UpdateReferrerGroupPayload>;
  updateReferrerGroupMapping?: Maybe<UpdateReferrerGroupMappingPayload>;
  updateShippingAddress: UpdateShippingAddressPayload;
  updateSize: UpdateSizePayload;
  updateSizePositions?: Maybe<UpdateSizePositionsPayload>;
  updateStore: UpdateStorePayload;
  updateStoreAssignmentRole: UpdateStoreAssignmentRolePayload;
  updateTradein: UpdateTradeinPayload;
  updateTradeinApplication?: Maybe<UpdateTradeinApplicationPayload>;
  updateTradeinLineItemAssessment: UpdateTradeinLineItemAssessmentPayload;
  updateTradeinLineItemCustomerResponse: UpdateTradeinLineItemCustomerResponsePayload;
  updateTradeinLineItemEligibility: UpdateTradeinLineItemEligibilityPayload;
  updateTradeinLineItemReturnedShipping: UpdateTradeinLineItemReturnedShippingPayload;
  updateUserNewsletterStatus: UpdateUserNewsletterStatusPayload;
  verifyAmazonPayment: VerifyAmazonPaymentPayload;
  verifyCard: VerifyCardPayload;
  verifyPayment: VerifyPaymentPayload;
};


export type MutationAcceptTradeinItemsArgs = {
  input: AcceptTradeinItemsInput;
};


export type MutationActivateBrandUserArgs = {
  input: ActivateBrandUserInput;
};


export type MutationAddItemArgs = {
  input: AddItemInput;
};


export type MutationAddressArgs = {
  input: AddressInput;
};


export type MutationAssignBrandUserToStoreArgs = {
  input: AssignBrandUserToStoreInput;
};


export type MutationBrandAdminBulkUpdateInventoryStatusArgs = {
  input: BrandAdminBulkUpdateInventoryStatusInput;
};


export type MutationBrandAdminCreateInventoryArgs = {
  input: BrandAdminCreateInventoryInput;
};


export type MutationBrandAdminReceiveInventoriesArgs = {
  input: BrandAdminReceiveInventoriesInput;
};


export type MutationBrandAdminUpdateInventoryArgs = {
  input: BrandAdminUpdateInventoryInput;
};


export type MutationBrandAdminUpdateTradeinItemArgs = {
  input: BrandAdminUpdateTradeinItemInput;
};


export type MutationBrandAdminUpdateTradeinLineItemArgs = {
  input: BrandAdminUpdateTradeinLineItemInput;
};


export type MutationCampaignArgs = {
  input: CampaignInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationClearTabletDisplayArgs = {
  input: ClearTabletDisplayInput;
};


export type MutationConfirmArgs = {
  input: ConfirmInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAmazonPayCheckoutPayloadArgs = {
  input: CreateCheckoutPayloadInput;
};


export type MutationCreateBrandArgs = {
  input: CreateBrandInput;
};


export type MutationCreateBrandImageArgs = {
  input: CreateBrandImageInput;
};


export type MutationCreateBrandUserArgs = {
  input: CreateBrandUserInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateConditionArgs = {
  input: CreateConditionInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateEventReservationArgs = {
  input: CreateEventReservationInput;
};


export type MutationCreateInventoryArgs = {
  input: CreateInventoryInput;
};


export type MutationCreateLikeArgs = {
  input: CreateLikeInput;
};


export type MutationCreateListingArgs = {
  input: CreateListingInput;
};


export type MutationCreateListingFromInventoryArgs = {
  input: CreateListingFromInventoryInput;
};


export type MutationCreateListingImageArgs = {
  input: CreateListingImageInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductImageArgs = {
  input: CreateProductImageInput;
};


export type MutationCreateProductMasterArgs = {
  input: CreateProductMasterInput;
};


export type MutationCreateProductVariationArgs = {
  input: CreateProductVariationInput;
};


export type MutationCreateReferrerGroupArgs = {
  input: CreateReferrerGroupInput;
};


export type MutationCreateReferrerGroupMappingArgs = {
  input: CreateReferrerGroupMappingInput;
};


export type MutationCreateSizeArgs = {
  input: CreateSizeInput;
};


export type MutationCreateStoreArgs = {
  input: CreateStoreInput;
};


export type MutationCreateTradeinArgs = {
  input: CreateTradeinInput;
};


export type MutationCreateTradeinApplicationArgs = {
  input: CreateTradeinApplicationInput;
};


export type MutationCreateTradeinPickupArgs = {
  input: CreateTradeinPickupInput;
};


export type MutationCreateTradeinReceptionArgs = {
  input: CreateTradeinReceptionInput;
};


export type MutationDeactivateBrandUserArgs = {
  input: DeactivateBrandUserInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteBrandImageArgs = {
  input: DeleteBrandImageInput;
};


export type MutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type MutationDeleteLikeArgs = {
  input: DeleteLikeInput;
};


export type MutationDeleteListingArgs = {
  input: DeleteListingInput;
};


export type MutationDeleteListingImageArgs = {
  input: DeleteListingImageInput;
};


export type MutationDeletePaymentArgs = {
  input: DeletePaymentInput;
};


export type MutationDeleteProductImageArgs = {
  input: DeleteProductImageInput;
};


export type MutationDeleteReferrerGroupArgs = {
  input: DeleteReferrerGroupInput;
};


export type MutationDeleteReferrerGroupMappingArgs = {
  input: DeleteReferrerGroupMappingInput;
};


export type MutationDeleteStoreArgs = {
  input: DeleteStoreInput;
};


export type MutationDeleteTabletArgs = {
  input: DeleteTabletInput;
};


export type MutationDeleteTradeinAssetArgs = {
  input: DeleteTradeinAssetInput;
};


export type MutationDeleteTradeinVerificationAssetsArgs = {
  input: DeleteTradeinVerificationAssetsInput;
};


export type MutationEmailChangeConfirmationArgs = {
  input: EmailChangeConfirmationInput;
};


export type MutationExportListingsCsvArgs = {
  input: ExportListingsCsvInput;
};


export type MutationExportOrdersCsvArgs = {
  input: ExportOrdersCsvInput;
};


export type MutationExportProductMastersCsvArgs = {
  input: ExportProductMastersCsvInput;
};


export type MutationExportProductsCsvArgs = {
  input: ExportProductsCsvInput;
};


export type MutationExportProductsCsvAdminArgs = {
  input: ExportProductsCsvAdminInput;
};


export type MutationExportUsersCsvArgs = {
  input: ExportUsersCsvInput;
};


export type MutationExportWarrantyCsvArgs = {
  input: ExportWarrantyCsvInput;
};


export type MutationFetchGoogleMerchantStatusArgs = {
  input: FetchGoogleMerchantStatusInput;
};


export type MutationGeneratePresignedUrlArgs = {
  input: GeneratePresignedUrlInput;
};


export type MutationGenerateShopifyAuthUrlArgs = {
  input: GenerateAuthUrlInput;
};


export type MutationGuestCheckoutArgs = {
  input: GuestCheckoutInput;
};


export type MutationGuestConfirmArgs = {
  input: GuestConfirmInput;
};


export type MutationImportAdCostsArgs = {
  input: ImportAdCostsInput;
};


export type MutationImportProductMastersCsvArgs = {
  input: ImportProductMastersCsvInput;
};


export type MutationImportProductsCsvArgs = {
  input: ImportProductsCsvInput;
};


export type MutationIssueShopifyDiscountCodeArgs = {
  input: IssueShopifyDiscountCodeInput;
};


export type MutationLoginWithShopifyStorefrontArgs = {
  input: LoginWithStorefrontInput;
};


export type MutationOrderArgs = {
  input: OrderInput;
};


export type MutationRegisterInventoryFromTradeinLineItemArgs = {
  input: RegisterInventoryFromTradeinLineItemInput;
};


export type MutationRegisterTabletArgs = {
  input: RegisterTabletInput;
};


export type MutationRemoveItemArgs = {
  input: RemoveItemInput;
};


export type MutationResendConfirmationArgs = {
  input: ResendConfirmationInput;
};


export type MutationResetBrandUserPasswordArgs = {
  input: ResetBrandUserPasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSendSmsNotificationArgs = {
  input: SendSmsNotificationInput;
};


export type MutationSigninArgs = {
  input: SigninInput;
};


export type MutationSigninBrandAdminArgs = {
  input: SigninBrandAdminInput;
};


export type MutationSigninKishArgs = {
  input: SigninKishInput;
};


export type MutationSignoutArgs = {
  input: SignoutInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSignupConfirmationArgs = {
  input: SignupConfirmationInput;
};


export type MutationSubscribeNewsletterArgs = {
  input: SubscribeNewsletterInput;
};


export type MutationSyncListingToGoogleMerchantArgs = {
  input: SyncListingToGoogleMerchantInput;
};


export type MutationTriggerTabletDisplayArgs = {
  input: TriggerTabletDisplayInput;
};


export type MutationUnassignBrandUserFromStoreArgs = {
  input: UnassignBrandUserFromStoreInput;
};


export type MutationUnsubscribeCartReminderByTokenArgs = {
  input: UnsubscribeCartReminderByTokenInput;
};


export type MutationUnsubscribeNewsletterArgs = {
  input: UnsubscribeNewsletterInput;
};


export type MutationUnsubscribeNewsletterByTokenArgs = {
  input: UnsubscribeNewsletterByTokenInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandInput;
};


export type MutationUpdateBrandEmailSettingsArgs = {
  input: UpdateBrandEmailSettingsInput;
};


export type MutationUpdateBrandImageArgs = {
  input: UpdateBrandImageInput;
};


export type MutationUpdateBrandUserArgs = {
  input: UpdateBrandUserInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCartReminderSettingArgs = {
  input: UpdateCartReminderSettingInput;
};


export type MutationUpdateCartReminderSubscriptionArgs = {
  input: UpdateCartReminderSubscriptionInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateCategoryPositionsArgs = {
  input: UpdateCategoryPositionsInput;
};


export type MutationUpdateColorArgs = {
  input: UpdateColorInput;
};


export type MutationUpdateConditionArgs = {
  input: UpdateConditionInput;
};


export type MutationUpdateConditionPositionsArgs = {
  input: UpdateConditionPositionsInput;
};


export type MutationUpdateInventoryArgs = {
  input: UpdateInventoryInput;
};


export type MutationUpdateListingArgs = {
  input: UpdateListingInput;
};


export type MutationUpdateListingImageArgs = {
  input: UpdateListingImageInput;
};


export type MutationUpdateListingImagePositionArgs = {
  input: UpdateListingImagePositionInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePrimaryAddressArgs = {
  input: UpdatePrimaryAddressInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductImageArgs = {
  input: UpdateProductImageInput;
};


export type MutationUpdateProductImagePositionArgs = {
  input: UpdateProductImagePositionInput;
};


export type MutationUpdateProductMasterArgs = {
  input: UpdateProductMasterInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateReferrerGroupArgs = {
  input: UpdateReferrerGroupInput;
};


export type MutationUpdateReferrerGroupMappingArgs = {
  input: UpdateReferrerGroupMappingInput;
};


export type MutationUpdateShippingAddressArgs = {
  input: UpdateShippingAddressInput;
};


export type MutationUpdateSizeArgs = {
  input: UpdateSizeInput;
};


export type MutationUpdateSizePositionsArgs = {
  input: UpdateSizePositionsInput;
};


export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput;
};


export type MutationUpdateStoreAssignmentRoleArgs = {
  input: UpdateStoreAssignmentRoleInput;
};


export type MutationUpdateTradeinArgs = {
  input: UpdateTradeinInput;
};


export type MutationUpdateTradeinApplicationArgs = {
  input: UpdateTradeinApplicationInput;
};


export type MutationUpdateTradeinLineItemAssessmentArgs = {
  input: UpdateTradeinLineItemAssessmentInput;
};


export type MutationUpdateTradeinLineItemCustomerResponseArgs = {
  input: UpdateTradeinLineItemCustomerResponseInput;
};


export type MutationUpdateTradeinLineItemEligibilityArgs = {
  input: UpdateTradeinLineItemEligibilityInput;
};


export type MutationUpdateTradeinLineItemReturnedShippingArgs = {
  input: UpdateTradeinLineItemReturnedShippingInput;
};


export type MutationUpdateUserNewsletterStatusArgs = {
  input: UpdateUserNewsletterStatusInput;
};


export type MutationVerifyAmazonPaymentArgs = {
  input: VerifyAmazonPaymentInput;
};


export type MutationVerifyCardArgs = {
  input: VerifyCardInput;
};


export type MutationVerifyPaymentArgs = {
  input: VerifyPaymentInput;
};

export type NewsletterSubscriber = {
  __typename?: 'NewsletterSubscriber';
  brand: Brand;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGuest: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subscribedAt?: Maybe<Scalars['DateTime']['output']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type NotificationAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Order = {
  __typename?: 'Order';
  brand?: Maybe<Brand>;
  brandId: Scalars['ID']['output'];
  campaign?: Maybe<Campaign>;
  channel?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  guestPaymentMaskedCard?: Maybe<Scalars['String']['output']>;
  guestTel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemTotalPrice?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Item>>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  paymentStatusI18n?: Maybe<Scalars['String']['output']>;
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingAddress?: Maybe<ShippingAddress>;
  shippingStatus?: Maybe<Scalars['String']['output']>;
  shippingStatusI18n?: Maybe<Scalars['String']['output']>;
  shippingTotalPrice?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusI18n?: Maybe<Scalars['String']['output']>;
  strageLocation?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid: Scalars['ID']['output'];
};

export type OrderAttributes = {
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  shippedAt?: InputMaybe<Scalars['DateTime']['input']>;
  shippingStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAttributionAttributes = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of Order */
export type OrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
};

/** Autogenerated return type of Order. */
export type OrderPayload = {
  __typename?: 'OrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  requiresCardReregistration?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderPurchase = {
  __typename?: 'OrderPurchase';
  itemTotalPrice?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Item>>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  shippingTotalPrice?: Maybe<Scalars['Int']['output']>;
};

export type OrderSearch = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  orderDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  shippedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shippedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  shippingStatus?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSummary = {
  __typename?: 'OrderSummary';
  /** カスタム期間の受注サマリー */
  custom?: Maybe<OrderSummaryPeriod>;
  /** 先月の受注サマリー */
  lastMonth: OrderSummaryPeriod;
  /** 今月の受注サマリー */
  thisMonth: OrderSummaryPeriod;
  /** 今日の受注サマリー */
  today: OrderSummaryPeriod;
  /** 昨日の受注サマリー */
  yesterday: OrderSummaryPeriod;
};

export type OrderSummaryPeriod = {
  __typename?: 'OrderSummaryPeriod';
  /** 受注件数 */
  orderCount: Scalars['Int']['output'];
  /** 期間ラベル (today, yesterday, this_month, last_month, custom) */
  period: Scalars['String']['output'];
  /** 期間表示名 (今日, 昨日, 今月, 先月, カスタム) */
  periodLabel: Scalars['String']['output'];
  /** 配送完了金額 */
  shippedAmount: Scalars['Int']['output'];
  /** 配送完了件数 */
  shippedCount: Scalars['Int']['output'];
  /** 受注額合計 */
  totalAmount: Scalars['Int']['output'];
};

export type Orders = {
  __typename?: 'Orders';
  orders: Array<Order>;
  pagination: Pagination;
};

export type Organization = {
  __typename?: 'Organization';
  brands: Array<Brand>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sellers: Array<Seller>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentCount: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  previousPage?: Maybe<Scalars['Int']['output']>;
  resultsCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PartnerInventoryTab = {
  __typename?: 'PartnerInventoryTab';
  action?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  statuses: Array<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type PartnerInventoryWorkflow = {
  __typename?: 'PartnerInventoryWorkflow';
  editableStatuses: Array<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  tabs: Array<PartnerInventoryTab>;
  visibleStatuses: Array<Scalars['String']['output']>;
};

export type PasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSecurityCodeSet?: Maybe<Scalars['String']['output']>;
  maskedCardNo?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  toBeExpiredAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
};

export type PaymentAttributes = {
  isSecurityCodeSet?: InputMaybe<Scalars['Boolean']['input']>;
  maskedCardNo?: InputMaybe<Scalars['String']['input']>;
  paymentToken: Scalars['String']['input'];
  toBeExpiredAt?: InputMaybe<Scalars['String']['input']>;
};

/** 決済方法 */
export enum PaymentMethod {
  /** Amazon Pay */
  AmazonPay = 'AMAZON_PAY',
  /** クレジットカード */
  CreditCard = 'CREDIT_CARD',
  /** PayPay */
  Paypay = 'PAYPAY'
}

export type Product = {
  __typename?: 'Product';
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Color>;
  colorId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Image>>;
  isArchive: Scalars['Boolean']['output'];
  isResale: Scalars['Boolean']['output'];
  isSoldOut: Scalars['Boolean']['output'];
  listings?: Maybe<Array<Listing>>;
  listingsCount: Scalars['Int']['output'];
  productMaster: ProductMaster;
  productMasterId?: Maybe<Scalars['ID']['output']>;
  recommendationScore?: Maybe<Scalars['Int']['output']>;
  salesListings?: Maybe<Array<Listing>>;
  sizes?: Maybe<Array<Size>>;
  status: Scalars['String']['output'];
  statusI18n?: Maybe<Scalars['String']['output']>;
  styleColor?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ProductAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  colorId?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  isResale?: InputMaybe<Scalars['Boolean']['input']>;
  recommendationScore?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  styleColor?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMaster = {
  __typename?: 'ProductMaster';
  brand: Brand;
  brandId: Scalars['ID']['output'];
  care?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Category>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTitle?: Maybe<Scalars['String']['output']>;
  detailDescription?: Maybe<Scalars['String']['output']>;
  fill?: Maybe<Scalars['String']['output']>;
  fit?: Maybe<Scalars['String']['output']>;
  hood?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lengthType?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  priceTotal?: Maybe<Scalars['Int']['output']>;
  /** カラーバリエーション（商品一覧） */
  products?: Maybe<Array<Product>>;
  recommendedScene?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  sexI18n?: Maybe<Scalars['String']['output']>;
  sizeGuide?: Maybe<Scalars['String']['output']>;
  sizeGuides?: Maybe<Array<SizeGuide>>;
  sizes?: Maybe<Array<Size>>;
  styleColor?: Maybe<Scalars['String']['output']>;
  sustainability?: Maybe<Scalars['String']['output']>;
  tradeinPrice?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
  year?: Maybe<Scalars['String']['output']>;
};

export type ProductMasterAttributes = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  care?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionTitle?: InputMaybe<Scalars['String']['input']>;
  detailDescription?: InputMaybe<Scalars['String']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<Scalars['String']['input']>;
  hood?: InputMaybe<Scalars['String']['input']>;
  lengthType?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceTotal?: InputMaybe<Scalars['Int']['input']>;
  recommendedScene?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sizeGuide?: InputMaybe<Scalars['String']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  styleColor?: InputMaybe<Scalars['String']['input']>;
  sustainability?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMasterSearch = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** code / name を OR ILIKE 検索 */
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMasters = {
  __typename?: 'ProductMasters';
  pagination: Pagination;
  productMasters: Array<ProductMaster>;
  totalCount: Scalars['Int']['output'];
};

export type ProductSearch = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 出品状況 (with_listings / without_listings) */
  hasListings?: InputMaybe<Scalars['String']['input']>;
  isArchive?: InputMaybe<Scalars['String']['input']>;
  isResale?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  listingConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listingSizeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productMasterName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** ステータス (draft / publish) */
  status?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};

export type Products = {
  __typename?: 'Products';
  pagination: Pagination;
  products: Array<Product>;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  address?: Maybe<Address>;
  adminAllListings: Listings;
  allBrands: Brands;
  allCampaigns: Campaigns;
  allCategories: AdminCategories;
  allConditions: Conditions;
  allContacts: Contacts;
  allListings: Listings;
  allOrders: Orders;
  allProductMasters: ProductMasters;
  allProducts: Products;
  allSizes: Sizes;
  allTradeinPickups: TradeinPickups;
  allTradeins: Tradeins;
  allUsers: Users;
  amazonPayCheckoutSessionInfo: AmazonPaySessionInfo;
  brand?: Maybe<Brand>;
  brandAdminAdCosts?: Maybe<AdCosts>;
  brandAdminAntiqueLedger?: Maybe<AntiqueLedger>;
  brandAdminBrandUser?: Maybe<BrandUser>;
  brandAdminBrandUsers?: Maybe<BrandUsers>;
  brandAdminConditions: Array<Condition>;
  brandAdminContact?: Maybe<Contact>;
  brandAdminContacts?: Maybe<Contacts>;
  brandAdminInventories?: Maybe<Inventories>;
  brandAdminListing?: Maybe<Listing>;
  brandAdminListings?: Maybe<Listings>;
  brandAdminOrder?: Maybe<Order>;
  brandAdminOrderSummary?: Maybe<OrderSummary>;
  brandAdminOrders?: Maybe<Orders>;
  brandAdminProduct?: Maybe<Product>;
  brandAdminProducts?: Maybe<Products>;
  brandAdminReferrerGroupMappings: Array<ReferrerGroupMapping>;
  brandAdminReferrerGroups: Array<ReferrerGroup>;
  brandAdminSalesReport?: Maybe<SalesReport>;
  brandAdminStore?: Maybe<Store>;
  brandAdminStores?: Maybe<Stores>;
  brandAdminTodayListings?: Maybe<TodayListingsSummary>;
  brandAdminTradein?: Maybe<Tradein>;
  brandAdminTradeins?: Maybe<Tradeins>;
  brandAdminUnmappedSourceMediums: Array<UnmappedSourceMedium>;
  brandNotifications: Array<Notification>;
  brandProductMasterList: Array<ProductMaster>;
  brandProductSearch: Products;
  brandProducts: Products;
  brands: Array<Brand>;
  campaign: Campaign;
  categories: Array<Category>;
  category: Category;
  colors: Array<Color>;
  completedOrder?: Maybe<OrderPurchase>;
  condition: Condition;
  conditions: Array<Condition>;
  contact: Contact;
  currentBrandUser?: Maybe<BrandUser>;
  currentOrder: Order;
  currentUser?: Maybe<User>;
  eventReservations: Array<EventReservation>;
  inventories: Inventories;
  inventory: Inventory;
  listing?: Maybe<Listing>;
  listingCategories: Array<Category>;
  listingConditions: Array<Condition>;
  listingGenders: Array<Gender>;
  listingSizes: Array<Size>;
  listings: Listings;
  myOrders: Orders;
  newsletterSubscription?: Maybe<NewsletterSubscriber>;
  order: Order;
  orders: Orders;
  organizations: Array<Organization>;
  product?: Maybe<Product>;
  productMaster: ProductMaster;
  productMasterDetail?: Maybe<ProductMaster>;
  products: Products;
  productsBySex: Products;
  publicStore?: Maybe<Store>;
  recommendedListings?: Maybe<Array<Listing>>;
  recommendedProducts?: Maybe<Array<Product>>;
  sizes: Array<Size>;
  storageLocations: Array<StorageLocation>;
  tradein: Tradein;
  tradeinApplicationByUuid?: Maybe<TradeinApplication>;
  tradeinApplications: Array<TradeinApplication>;
  tradeinPickupPrefill?: Maybe<TradeinPickupPrefill>;
  tradeinReceptionByNumber?: Maybe<TradeinReception>;
  tradeinReceptions: Array<TradeinReception>;
  user?: Maybe<User>;
};


export type QueryAddressArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryAdminAllListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListingSearch>;
};


export type QueryAllBrandsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCampaignsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCategoriesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllConditionsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllContactsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ContactSearch>;
};


export type QueryAllListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListingSearch>;
};


export type QueryAllOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<OrderSearch>;
};


export type QueryAllProductMastersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductMasterSearch>;
};


export type QueryAllProductsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductSearch>;
};


export type QueryAllSizesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTradeinPickupsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  pickupDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  pickupDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryAllTradeinsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<TradeinSearch>;
};


export type QueryAllUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search: UserSearchInput;
};


export type QueryAmazonPayCheckoutSessionInfoArgs = {
  checkoutSessionId: Scalars['String']['input'];
};


export type QueryBrandArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminAdCostsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  referrerGroupUuid?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryBrandAdminAntiqueLedgerArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AntiqueLedgerSearchAttributes>;
};


export type QueryBrandAdminBrandUserArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminBrandUsersArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandAdminConditionsArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryBrandAdminContactArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminContactsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ContactSearch>;
};


export type QueryBrandAdminInventoriesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<InventorySearchAttributes>;
};


export type QueryBrandAdminListingArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminListingsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListingSearch>;
};


export type QueryBrandAdminOrderArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminOrderSummaryArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryBrandAdminOrdersArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<OrderSearch>;
};


export type QueryBrandAdminProductArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminProductsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductSearch>;
};


export type QueryBrandAdminReferrerGroupMappingsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandAdminReferrerGroupsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandAdminSalesReportArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  mode?: InputMaybe<SalesReportMode>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryBrandAdminStoreArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminStoresArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandAdminTodayListingsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandAdminTradeinArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryBrandAdminTradeinsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<TradeinSearch>;
};


export type QueryBrandAdminUnmappedSourceMediumsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandNotificationsArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryBrandProductMasterListArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryBrandProductSearchArgs = {
  brandId: Scalars['ID']['input'];
  search?: InputMaybe<ProductSearch>;
};


export type QueryBrandProductsArgs = {
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductSearch>;
};


export type QueryCampaignArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryCategoryArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryColorsArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryCompletedOrderArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryConditionArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryConditionsArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryContactArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryCurrentOrderArgs = {
  brandUuid: Scalars['ID']['input'];
};


export type QueryInventoriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<InventorySearchAttributes>;
};


export type QueryInventoryArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryListingArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryListingCategoriesArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryListingConditionsArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryListingGendersArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryListingSizesArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryListingsArgs = {
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListingSearch>;
};


export type QueryMyOrdersArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsletterSubscriptionArgs = {
  brandUuid: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<OrderSearch>;
};


export type QueryProductArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryProductMasterArgs = {
  brandId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type QueryProductMasterDetailArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductSearch>;
};


export type QueryProductsBySexArgs = {
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sex: Scalars['String']['input'];
};


export type QueryPublicStoreArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryRecommendedListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingUuid: Scalars['ID']['input'];
};


export type QueryRecommendedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  productUuid: Scalars['ID']['input'];
};


export type QuerySizesArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryStorageLocationsArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryTradeinArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryTradeinApplicationByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryTradeinApplicationsArgs = {
  storeUuid: Scalars['ID']['input'];
};


export type QueryTradeinPickupPrefillArgs = {
  tradeinUuid: Scalars['ID']['input'];
};


export type QueryTradeinReceptionByNumberArgs = {
  receptionNumber: Scalars['Int']['input'];
  storeUuid: Scalars['ID']['input'];
};


export type QueryTradeinReceptionsArgs = {
  storeUuid: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  uuid: Scalars['ID']['input'];
};

export type ReferrerGroup = {
  __typename?: 'ReferrerGroup';
  /** 広告媒体グループか（キャンペーン別内訳の展開対象） */
  isAd: Scalars['Boolean']['output'];
  /** 紐づく参照元の数 */
  mappingsCount: Scalars['Int']['output'];
  /** グループ名 */
  name: Scalars['String']['output'];
  /** レポートでの表示順 */
  position: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type ReferrerGroupAttributes = {
  isAd?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferrerGroupMapping = {
  __typename?: 'ReferrerGroupMapping';
  referrerGroup: ReferrerGroup;
  /** GA4の sessionSource / sessionMedium */
  sourceMedium: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Autogenerated input type of RegisterInventoryFromTradeinLineItem */
export type RegisterInventoryFromTradeinLineItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of RegisterInventoryFromTradeinLineItem. */
export type RegisterInventoryFromTradeinLineItemPayload = {
  __typename?: 'RegisterInventoryFromTradeinLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

/** Autogenerated input type of RegisterTablet */
export type RegisterTabletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  storeUuid: Scalars['String']['input'];
};

/** Autogenerated return type of RegisterTablet. */
export type RegisterTabletPayload = {
  __typename?: 'RegisterTabletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Tablet>;
};

/** Autogenerated input type of RemoveItem */
export type RemoveItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingUuid: Scalars['ID']['input'];
  orderUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveItem. */
export type RemoveItemPayload = {
  __typename?: 'RemoveItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of ResendConfirmation */
export type ResendConfirmationInput = {
  brandId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResendConfirmation. */
export type ResendConfirmationPayload = {
  __typename?: 'ResendConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ResetBrandUserPassword */
export type ResetBrandUserPasswordInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetBrandUserPassword. */
export type ResetBrandUserPasswordPayload = {
  __typename?: 'ResetBrandUserPasswordPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  brandId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SalesReport = {
  __typename?: 'SalesReport';
  /** GA4プロパティIDが設定済みか */
  gaConnected: Scalars['Boolean']['output'];
  /** 期間合計（startOn/endOn は期間全体） */
  total: SalesReportWeek;
  /** 週次の集計結果 */
  weeks: Array<SalesReportWeek>;
};

export type SalesReportBreakdownCount = {
  __typename?: 'SalesReportBreakdownCount';
  /** 在庫件数 */
  count: Scalars['Int']['output'];
  /** 内訳のキー（未設定は null） */
  key?: Maybe<Scalars['ID']['output']>;
  /** 内訳の表示名 */
  name: Scalars['String']['output'];
};

export type SalesReportBreakdownMetric = {
  __typename?: 'SalesReportBreakdownMetric';
  /** 受注額 */
  amount: Scalars['Int']['output'];
  /** 受注アイテム数 */
  itemCount: Scalars['Int']['output'];
  /** 内訳のキー（未設定は null） */
  key?: Maybe<Scalars['ID']['output']>;
  /** 内訳の表示名 */
  name: Scalars['String']['output'];
};

export type SalesReportCampaignMetric = {
  __typename?: 'SalesReportCampaignMetric';
  /** コンバージョン（流入元記録つき注文数） */
  conversions: Scalars['Int']['output'];
  /** 広告費用（未登録は null） */
  cost?: Maybe<Scalars['Int']['output']>;
  /** CPA（広告費用 ÷ コンバージョン） */
  cpa?: Maybe<Scalars['Int']['output']>;
  /** クリエイティブ別内訳 */
  creatives: Array<SalesReportCreativeMetric>;
  /** コンバージョン（GA4） */
  gaConversions: Scalars['Int']['output'];
  /** 購入金額（GA4のgrossPurchaseRevenue・返金前） */
  gaPurchaseRevenue: Scalars['Int']['output'];
  /** キャンペーン名（GA4の sessionCampaignName / 注文の utm_campaign） */
  name: Scalars['String']['output'];
  /** 購入金額（注文の受注額） */
  purchaseRevenue: Scalars['Int']['output'];
  /** ROAS（購入金額 ÷ 広告費用） */
  roas?: Maybe<Scalars['Float']['output']>;
  /** トラフィック */
  sessions: Scalars['Int']['output'];
};

export type SalesReportCreativeMetric = {
  __typename?: 'SalesReportCreativeMetric';
  /** コンバージョン（流入元記録つき注文数） */
  conversions: Scalars['Int']['output'];
  /** クリエイティブ名（注文の utm_content） */
  name: Scalars['String']['output'];
  /** 購入金額（注文の受注額） */
  purchaseRevenue: Scalars['Int']['output'];
};

export type SalesReportCustomerMetrics = {
  __typename?: 'SalesReportCustomerMetrics';
  /** 性別×年代の内訳 */
  bySexAge: Array<SalesReportSexAgeCount>;
  /** リピート顧客数（購入した週より前に購入履歴がある人数。合計は期間全体で重複を除く） */
  repeatCount: Scalars['Int']['output'];
  /** 購入顧客数 */
  total: Scalars['Int']['output'];
};

export type SalesReportInventoryMetrics = {
  __typename?: 'SalesReportInventoryMetrics';
  /** カテゴリー別内訳 */
  byCategory: Array<SalesReportBreakdownCount>;
  /** サイズ別内訳 */
  bySize: Array<SalesReportBreakdownCount>;
  /** 在庫消化率（前週末スナップショットがない週は null） */
  sellThroughRate?: Maybe<Scalars['Float']['output']>;
  /** 新品・B品アイテム数 */
  stockItemCount?: Maybe<Scalars['Int']['output']>;
  /** 在庫数（週末時点。スナップショットがない週は null） */
  total?: Maybe<Scalars['Int']['output']>;
  /** 下取りアイテム数 */
  tradeInCount?: Maybe<Scalars['Int']['output']>;
};

/** 販売レポートの表示モード */
export enum SalesReportMode {
  /** 確定値（レポート用）: 各週の数値を週締め時点のキャンセル状況で確定 */
  Fixed = 'FIXED',
  /** 最新値: 現在時点のキャンセル反映済み */
  Latest = 'LATEST'
}

export type SalesReportOrderMetrics = {
  __typename?: 'SalesReportOrderMetrics';
  /** 受注額 */
  amount: Scalars['Int']['output'];
  /** カテゴリー別内訳 */
  byCategory: Array<SalesReportBreakdownMetric>;
  /** サイズ別内訳 */
  bySize: Array<SalesReportBreakdownMetric>;
  /** 受注数 */
  count: Scalars['Int']['output'];
  /** 受注アイテム数 */
  itemCount: Scalars['Int']['output'];
};

export type SalesReportReferrerGroupMetric = {
  __typename?: 'SalesReportReferrerGroupMetric';
  /** キャンペーン別内訳（isAd が true のグループのみ） */
  campaigns?: Maybe<Array<SalesReportCampaignMetric>>;
  /** コンバージョン（流入元記録つき注文数） */
  conversions: Scalars['Int']['output'];
  /** 広告費用（未登録は null） */
  cost?: Maybe<Scalars['Int']['output']>;
  /** CPA（広告費用 ÷ コンバージョン） */
  cpa?: Maybe<Scalars['Int']['output']>;
  /** コンバージョン（GA4） */
  gaConversions: Scalars['Int']['output'];
  /** 購入金額（GA4のgrossPurchaseRevenue・返金前） */
  gaPurchaseRevenue: Scalars['Int']['output'];
  /** 広告媒体グループか */
  isAd: Scalars['Boolean']['output'];
  /** グループ名（マッピング未登録は Others、UTMなしの注文は 不明） */
  name: Scalars['String']['output'];
  /** 購入金額（注文の受注額） */
  purchaseRevenue: Scalars['Int']['output'];
  /** ROAS（購入金額 ÷ 広告費用） */
  roas?: Maybe<Scalars['Float']['output']>;
  /** トラフィック */
  sessions: Scalars['Int']['output'];
};

export type SalesReportSexAgeCount = {
  __typename?: 'SalesReportSexAgeCount';
  /** 年代（10s〜60s / 70s+ / unknown） */
  ageRange: Scalars['String']['output'];
  /** 購入顧客数 */
  count: Scalars['Int']['output'];
  /** 性別（men / women / unknown） */
  sex: Scalars['String']['output'];
};

export type SalesReportTrafficMetrics = {
  __typename?: 'SalesReportTrafficMetrics';
  /** 流入元グループ別内訳 */
  byGroup: Array<SalesReportReferrerGroupMetric>;
  /** コンバージョン（流入元記録つき注文数） */
  conversions: Scalars['Int']['output'];
  /** 広告費用（未登録は null） */
  cost?: Maybe<Scalars['Int']['output']>;
  /** CPA（広告費用 ÷ コンバージョン） */
  cpa?: Maybe<Scalars['Int']['output']>;
  /** コンバージョン（GA4のpurchaseイベント数） */
  gaConversions: Scalars['Int']['output'];
  /** 購入金額（GA4のgrossPurchaseRevenue・返金前） */
  gaPurchaseRevenue: Scalars['Int']['output'];
  /** 購入金額（注文の受注額） */
  purchaseRevenue: Scalars['Int']['output'];
  /** ROAS（購入金額 ÷ 広告費用） */
  roas?: Maybe<Scalars['Float']['output']>;
  /** トラフィック（GA4のセッション数） */
  sessions: Scalars['Int']['output'];
};

export type SalesReportWeek = {
  __typename?: 'SalesReportWeek';
  /** 顧客系の指標 */
  customers: SalesReportCustomerMetrics;
  /** 週の終了日（日曜） */
  endOn: Scalars['ISO8601Date']['output'];
  /** 在庫系の指標（スナップショット未取得の週は null） */
  inventory?: Maybe<SalesReportInventoryMetrics>;
  /** 受注系の指標 */
  order: SalesReportOrderMetrics;
  /** GA未確定日（直近48時間）を含む週か */
  provisional: Scalars['Boolean']['output'];
  /** 週の開始日（月曜） */
  startOn: Scalars['ISO8601Date']['output'];
  /** GA由来の指標（GA未接続・未取得は null） */
  traffic?: Maybe<SalesReportTrafficMetrics>;
};

export type Seller = {
  __typename?: 'Seller';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Autogenerated input type of SendSmsNotification */
export type SendSmsNotificationInput = {
  /** 下取り申請UUID */
  applicationUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendSmsNotification. */
export type SendSmsNotificationPayload = {
  __typename?: 'SendSmsNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameKana?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSave?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameKana?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  prefecture?: Maybe<Scalars['String']['output']>;
  prefectureI18n?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressAttributes = {
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameKana?: InputMaybe<Scalars['String']['input']>;
  isSave?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameKana?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SigninBrandAdmin */
export type SigninBrandAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of SigninBrandAdmin. */
export type SigninBrandAdminPayload = {
  __typename?: 'SigninBrandAdminPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of Signin */
export type SigninInput = {
  brandId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated input type of SigninKish */
export type SigninKishInput = {
  brandId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of SigninKish. */
export type SigninKishPayload = {
  __typename?: 'SigninKishPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated return type of Signin. */
export type SigninPayload = {
  __typename?: 'SigninPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of Signout */
export type SignoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Signout. */
export type SignoutPayload = {
  __typename?: 'SignoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type Signup = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  passwordAttributes: PasswordInput;
  userAttributes: UserInput;
};

/** Autogenerated input type of SignupConfirmation */
export type SignupConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of SignupConfirmation. */
export type SignupConfirmationPayload = {
  __typename?: 'SignupConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of Signup */
export type SignupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: Signup;
};

/** Autogenerated return type of Signup. */
export type SignupPayload = {
  __typename?: 'SignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Size = {
  __typename?: 'Size';
  brand: Brand;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type SizeAttributes = {
  brandId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type SizeGuide = {
  __typename?: 'SizeGuide';
  chestWidth?: Maybe<Scalars['String']['output']>;
  headCircumference?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  length?: Maybe<Scalars['String']['output']>;
  productMasterId: Scalars['ID']['output'];
  shoulderWidth?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Size>;
  sizeId: Scalars['ID']['output'];
  sleeveLength?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type Sizes = {
  __typename?: 'Sizes';
  pagination: Pagination;
  sizes: Array<Size>;
};

export type StorageLocation = {
  __typename?: 'StorageLocation';
  allowedStatuses: Array<StorageLocationAllowedStatus>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type StorageLocationAllowedStatus = {
  __typename?: 'StorageLocationAllowedStatus';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type Store = {
  __typename?: 'Store';
  brand: Brand;
  brandId: Scalars['ID']['output'];
  brandUsers: Array<BrandUser>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  storeAssignments: Array<StoreAssignment>;
  tablets: Array<Tablet>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type StoreAssignment = {
  __typename?: 'StoreAssignment';
  brandUser: BrandUser;
  brandUserId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  store: Store;
  storeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StoreAssignmentInput = {
  role?: InputMaybe<Scalars['String']['input']>;
  storeUuid: Scalars['ID']['input'];
};

export type StoreInput = {
  name: Scalars['String']['input'];
};

export type Stores = {
  __typename?: 'Stores';
  pagination: Pagination;
  stores: Array<Store>;
};

/** Autogenerated input type of SubscribeNewsletter */
export type SubscribeNewsletterInput = {
  brandUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of SubscribeNewsletter. */
export type SubscribeNewsletterPayload = {
  __typename?: 'SubscribeNewsletterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  newsletterSubscriber?: Maybe<NewsletterSubscriber>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncListingToGoogleMerchant */
export type SyncListingToGoogleMerchantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncListingToGoogleMerchant. */
export type SyncListingToGoogleMerchantPayload = {
  __typename?: 'SyncListingToGoogleMerchantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

export type Tablet = {
  __typename?: 'Tablet';
  /** SSE接続認証用トークン（端末セットアップ時に保存） */
  authToken: Scalars['String']['output'];
  brand: Brand;
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  store: Store;
  storeId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TodayListingsSummary = {
  __typename?: 'TodayListingsSummary';
  /** 当日の出品アイテム数 */
  count: Scalars['Int']['output'];
  /** 対象日 */
  date: Scalars['ISO8601Date']['output'];
};

export type Tradein = {
  __typename?: 'Tradein';
  birthday?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['ID']['output']>;
  building?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  externalMemberships: Array<ExternalMembership>;
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  giftCardIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identificationType?: Maybe<Scalars['String']['output']>;
  identificationTypeI18n?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  occupationI18n?: Maybe<Scalars['String']['output']>;
  prefecture: Scalars['String']['output'];
  prefectureI18n: Scalars['String']['output'];
  product?: Maybe<Product>;
  repairMethod: Scalars['String']['output'];
  repairMethodI18n?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusI18n?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tel: Scalars['String']['output'];
  tradeinAmount?: Maybe<Scalars['Int']['output']>;
  tradeinDiscountCodes?: Maybe<Array<TradeinDiscountCode>>;
  tradeinEligibility?: Maybe<Scalars['String']['output']>;
  tradeinEligibilityI18n?: Maybe<Scalars['String']['output']>;
  tradeinImages?: Maybe<Array<AssetImage>>;
  tradeinLineItems?: Maybe<Array<TradeinLineItem>>;
  user?: Maybe<User>;
  uuid: Scalars['ID']['output'];
  zip: Scalars['String']['output'];
};

export type TradeinApplication = {
  __typename?: 'TradeinApplication';
  /** 顧客が承諾したアイテムの合計金額 */
  acceptedAmount: Scalars['Int']['output'];
  /** 顧客が承諾したアイテム数 */
  acceptedCount: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  brandUser: BrandUser;
  brandUserId: Scalars['ID']['output'];
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 下取り可能アイテム数 */
  eligibleCount: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identificationType?: Maybe<Scalars['String']['output']>;
  identificationTypeI18n?: Maybe<Scalars['String']['output']>;
  identityVerified: Scalars['Boolean']['output'];
  /** 全アイテム数 */
  itemsCount: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefecture?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusI18n: Scalars['String']['output'];
  /** 下取り可能アイテムの合計金額 */
  totalAmount: Scalars['Int']['output'];
  tradeinItems: Array<TradeinItem>;
  tradeinReception: TradeinReception;
  tradeinReceptionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TradeinAttributes = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facePhoto?: InputMaybe<Scalars['File']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameKana?: InputMaybe<Scalars['String']['input']>;
  giftCardIssuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  identificationBack?: InputMaybe<Scalars['File']['input']>;
  identificationFront?: InputMaybe<Scalars['File']['input']>;
  identificationType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameKana?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  repairMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  tradeinAmount?: InputMaybe<Scalars['Int']['input']>;
  tradeinEligibility?: InputMaybe<Scalars['String']['input']>;
  utilityBill?: InputMaybe<Scalars['File']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type TradeinDiscountCode = {
  __typename?: 'TradeinDiscountCode';
  amount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  shopifyDiscountId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusI18n?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TradeinItem = {
  __typename?: 'TradeinItem';
  conditionCheck: Scalars['String']['output'];
  conditionCheckI18n: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** 回収後の下取り可否（possible / not_possible） */
  eligibility?: Maybe<Scalars['String']['output']>;
  eligibilityI18n?: Maybe<Scalars['String']['output']>;
  /** 受付時の査定結果（tag_check と condition_check の両方が possible か） */
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 特記事項（主に下取り不可の理由） */
  note?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['ID']['output'];
  size?: Maybe<Size>;
  sizeId?: Maybe<Scalars['ID']['output']>;
  tagCheck: Scalars['String']['output'];
  tagCheckI18n: Scalars['String']['output'];
  tradeinAmount?: Maybe<Scalars['Int']['output']>;
  tradeinApplication: TradeinApplication;
  tradeinApplicationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TradeinItemInput = {
  /** 状態の確認（possible/not_possible） */
  conditionCheck: Scalars['String']['input'];
  /** 商品UUID */
  productUuid: Scalars['ID']['input'];
  /** サイズID */
  sizeId?: InputMaybe<Scalars['ID']['input']>;
  /** タグの確認（possible/not_possible） */
  tagCheck: Scalars['String']['input'];
  /** 下取り金額 */
  tradeinAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type TradeinLineItem = {
  __typename?: 'TradeinLineItem';
  condition: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** お客様の回答（accepted/returned/collected、KISH入力） */
  customerResponse?: Maybe<Scalars['String']['output']>;
  customerResponseI18n?: Maybe<Scalars['String']['output']>;
  /** 下取り可否（possible/not_possible、EM企画入力） */
  eligibility?: Maybe<Scalars['String']['output']>;
  eligibilityI18n?: Maybe<Scalars['String']['output']>;
  /** ギフトカード付与完了日時 */
  giftCardIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 在庫登録済みの場合の在庫 */
  inventory?: Maybe<Inventory>;
  /** 特記事項（主に下取り不可の理由） */
  note?: Maybe<Scalars['String']['output']>;
  product: Product;
  productNumber?: Maybe<Scalars['String']['output']>;
  /** 返品発送日 */
  returnedShippedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 返品追跡番号 */
  returnedTrackingCode?: Maybe<Scalars['String']['output']>;
  tradein: Tradein;
  tradeinAmount?: Maybe<Scalars['Int']['output']>;
  tradeinCondition?: Maybe<Condition>;
  uuid: Scalars['ID']['output'];
};

export type TradeinLineItemInput = {
  /** 商品の状態 (good: 良好, fair: 問題あり) */
  condition?: InputMaybe<Scalars['String']['input']>;
  /** 製品番号 */
  productNumber: Scalars['String']['input'];
  /** 商品UUID */
  productUuid: Scalars['ID']['input'];
  /** 参考査定額 */
  tradeinAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type TradeinPickup = {
  __typename?: 'TradeinPickup';
  brand: Brand;
  building?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  packageCount: Scalars['Int']['output'];
  pickupDate: Scalars['ISO8601Date']['output'];
  pickupTimeFrom: Scalars['Int']['output'];
  pickupTimeTo: Scalars['Int']['output'];
  prefecture: Scalars['Int']['output'];
  prefectureI18n: Scalars['String']['output'];
  status: Scalars['String']['output'];
  street: Scalars['String']['output'];
  tel: Scalars['String']['output'];
  tradein?: Maybe<Tradein>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type TradeinPickupPrefill = {
  __typename?: 'TradeinPickupPrefill';
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestPickupStatus?: Maybe<Scalars['String']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  pickupDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pickupTimeFrom?: Maybe<Scalars['Int']['output']>;
  pickupTimeTo?: Maybe<Scalars['Int']['output']>;
  prefecture?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type TradeinPickups = {
  __typename?: 'TradeinPickups';
  pagination: Pagination;
  tradeinPickups: Array<TradeinPickup>;
};

export type TradeinReception = {
  __typename?: 'TradeinReception';
  brand: Brand;
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  lastNameKana?: Maybe<Scalars['String']['output']>;
  receptionNumber: Scalars['Int']['output'];
  store: Store;
  storeId: Scalars['ID']['output'];
  tel: Scalars['String']['output'];
  tradeinApplications: Array<TradeinApplication>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
};

export type TradeinSearch = {
  /** 申請日時（FROM） */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** 申請日時（TO） */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** 申請者名・商品名で検索 */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** 返送状態で絞り込み（pending / done） */
  returnStatus?: InputMaybe<Scalars['String']['input']>;
  /** ステータスで絞り込み */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Tradeins = {
  __typename?: 'Tradeins';
  pagination: Pagination;
  tradeins: Array<Tradein>;
};

/** Autogenerated input type of TriggerTabletDisplay */
export type TriggerTabletDisplayInput = {
  /** 下取り申請UUID */
  applicationUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** タブレットUUID */
  tabletUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerTabletDisplay. */
export type TriggerTabletDisplayPayload = {
  __typename?: 'TriggerTabletDisplayPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UnassignBrandUserFromStore */
export type UnassignBrandUserFromStoreInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  brandUserUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  storeUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UnassignBrandUserFromStore. */
export type UnassignBrandUserFromStorePayload = {
  __typename?: 'UnassignBrandUserFromStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnmappedSourceMedium = {
  __typename?: 'UnmappedSourceMedium';
  /** 最後に計測された日 */
  lastSeenOn: Scalars['ISO8601Date']['output'];
  /** 対象期間の合計セッション数 */
  sessions: Scalars['Int']['output'];
  sourceMedium: Scalars['String']['output'];
};

/** Autogenerated input type of UnsubscribeCartReminderByToken */
export type UnsubscribeCartReminderByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UnsubscribeCartReminderByToken. */
export type UnsubscribeCartReminderByTokenPayload = {
  __typename?: 'UnsubscribeCartReminderByTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnsubscribeNewsletterByToken */
export type UnsubscribeNewsletterByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UnsubscribeNewsletterByToken. */
export type UnsubscribeNewsletterByTokenPayload = {
  __typename?: 'UnsubscribeNewsletterByTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnsubscribeNewsletter */
export type UnsubscribeNewsletterInput = {
  brandUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnsubscribeNewsletter. */
export type UnsubscribeNewsletterPayload = {
  __typename?: 'UnsubscribeNewsletterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  newsletterSubscriber?: Maybe<NewsletterSubscriber>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
  attributes: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAddress. */
export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateBrandEmailSettings */
export type UpdateBrandEmailSettingsInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settings: Array<BrandEmailSettingInput>;
};

/** Autogenerated return type of UpdateBrandEmailSettings. */
export type UpdateBrandEmailSettingsPayload = {
  __typename?: 'UpdateBrandEmailSettingsPayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateBrandImage */
export type UpdateBrandImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['File']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateBrandImage. */
export type UpdateBrandImagePayload = {
  __typename?: 'UpdateBrandImagePayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateBrand */
export type UpdateBrandInput = {
  attributes: BrandAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateBrand. */
export type UpdateBrandPayload = {
  __typename?: 'UpdateBrandPayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateBrandUser */
export type UpdateBrandUserInput = {
  attributes: BrandUserInput;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  storeAssignments?: InputMaybe<Array<StoreAssignmentInput>>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateBrandUser. */
export type UpdateBrandUserPayload = {
  __typename?: 'UpdateBrandUserPayload';
  brandUser?: Maybe<BrandUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCampaign */
export type UpdateCampaignInput = {
  attributes: CampaignAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCampaign. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCartReminderSetting */
export type UpdateCartReminderSettingInput = {
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settings: CartReminderSettingInput;
};

/** Autogenerated return type of UpdateCartReminderSetting. */
export type UpdateCartReminderSettingPayload = {
  __typename?: 'UpdateCartReminderSettingPayload';
  cartReminderSetting?: Maybe<CartReminderSetting>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateCartReminderSubscription */
export type UpdateCartReminderSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateCartReminderSubscription. */
export type UpdateCartReminderSubscriptionPayload = {
  __typename?: 'UpdateCartReminderSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCategory */
export type UpdateCategoryInput = {
  attributes: CategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCategory. */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCategoryPositions */
export type UpdateCategoryPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateCategoryPositions. */
export type UpdateCategoryPositionsPayload = {
  __typename?: 'UpdateCategoryPositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateColor */
export type UpdateColorInput = {
  attributes: ColorAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateColor. */
export type UpdateColorPayload = {
  __typename?: 'UpdateColorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Color>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCondition */
export type UpdateConditionInput = {
  attributes: ConditionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCondition. */
export type UpdateConditionPayload = {
  __typename?: 'UpdateConditionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateConditionPositions */
export type UpdateConditionPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateConditionPositions. */
export type UpdateConditionPositionsPayload = {
  __typename?: 'UpdateConditionPositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateInventory */
export type UpdateInventoryInput = {
  attributes: InventoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateInventory. */
export type UpdateInventoryPayload = {
  __typename?: 'UpdateInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
};

/** Autogenerated input type of UpdateListingImage */
export type UpdateListingImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['File']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateListingImage. */
export type UpdateListingImagePayload = {
  __typename?: 'UpdateListingImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of UpdateListingImagePosition */
export type UpdateListingImagePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateListingImagePosition. */
export type UpdateListingImagePositionPayload = {
  __typename?: 'UpdateListingImagePositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateListing */
export type UpdateListingInput = {
  attributes: ListingAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateListing. */
export type UpdateListingPayload = {
  __typename?: 'UpdateListingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<Listing>;
};

/** Autogenerated input type of UpdateOrder */
export type UpdateOrderInput = {
  attributes: OrderAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOrder. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of UpdatePassword */
export type UpdatePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePassword. */
export type UpdatePasswordPayload = {
  __typename?: 'UpdatePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdatePayment */
export type UpdatePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentAttributes: PaymentAttributes;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePayment. */
export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdatePrimaryAddress */
export type UpdatePrimaryAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePrimaryAddress. */
export type UpdatePrimaryAddressPayload = {
  __typename?: 'UpdatePrimaryAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProductImage */
export type UpdateProductImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['File']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProductImage. */
export type UpdateProductImagePayload = {
  __typename?: 'UpdateProductImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of UpdateProductImagePosition */
export type UpdateProductImagePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateProductImagePosition. */
export type UpdateProductImagePositionPayload = {
  __typename?: 'UpdateProductImagePositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInput = {
  attributes: ProductAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateProductMaster */
export type UpdateProductMasterInput = {
  attributes: ProductMasterAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProductMaster. */
export type UpdateProductMasterPayload = {
  __typename?: 'UpdateProductMasterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  productMaster: ProductMaster;
};

/** Autogenerated return type of UpdateProduct. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

export type UpdateProfile = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameKana?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameKana?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateProfile */
export type UpdateProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: UpdateProfile;
};

/** Autogenerated return type of UpdateProfile. */
export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateReferrerGroup */
export type UpdateReferrerGroupInput = {
  attributes: ReferrerGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateReferrerGroupMapping */
export type UpdateReferrerGroupMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referrerGroupUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateReferrerGroupMapping. */
export type UpdateReferrerGroupMappingPayload = {
  __typename?: 'UpdateReferrerGroupMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  referrerGroupMapping?: Maybe<ReferrerGroupMapping>;
};

/** Autogenerated return type of UpdateReferrerGroup. */
export type UpdateReferrerGroupPayload = {
  __typename?: 'UpdateReferrerGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  referrerGroup?: Maybe<ReferrerGroup>;
};

/** Autogenerated input type of UpdateShippingAddress */
export type UpdateShippingAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['ID']['input'];
  shippingAddressAttributes: ShippingAddressAttributes;
};

/** Autogenerated return type of UpdateShippingAddress. */
export type UpdateShippingAddressPayload = {
  __typename?: 'UpdateShippingAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of UpdateSize */
export type UpdateSizeInput = {
  attributes: SizeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSize. */
export type UpdateSizePayload = {
  __typename?: 'UpdateSizePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Size>;
};

/** Autogenerated input type of UpdateSizePositions */
export type UpdateSizePositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateSizePositions. */
export type UpdateSizePositionsPayload = {
  __typename?: 'UpdateSizePositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateStoreAssignmentRole */
export type UpdateStoreAssignmentRoleInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  brandUserUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  storeUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStoreAssignmentRole. */
export type UpdateStoreAssignmentRolePayload = {
  __typename?: 'UpdateStoreAssignmentRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  storeAssignment?: Maybe<StoreAssignment>;
};

/** Autogenerated input type of UpdateStore */
export type UpdateStoreInput = {
  attributes: StoreInput;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStore. */
export type UpdateStorePayload = {
  __typename?: 'UpdateStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Store>;
};

/** Autogenerated input type of UpdateTradeinApplication */
export type UpdateTradeinApplicationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<Scalars['String']['input']>;
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTradeinApplication. */
export type UpdateTradeinApplicationPayload = {
  __typename?: 'UpdateTradeinApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinApplication?: Maybe<TradeinApplication>;
};

/** Autogenerated input type of UpdateTradein */
export type UpdateTradeinInput = {
  attributes: TradeinAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateTradeinLineItemAssessment */
export type UpdateTradeinLineItemAssessmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** accepted / returned / collected */
  customerResponse?: InputMaybe<Scalars['String']['input']>;
  /** ギフトカード付与完了日時 */
  giftCardIssuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** 下取金額（参考査定額） */
  tradeinAmount?: InputMaybe<Scalars['Int']['input']>;
  /** 下取り状態（Condition）の UUID */
  tradeinConditionUuid?: InputMaybe<Scalars['ID']['input']>;
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTradeinLineItemAssessment. */
export type UpdateTradeinLineItemAssessmentPayload = {
  __typename?: 'UpdateTradeinLineItemAssessmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

/** Autogenerated input type of UpdateTradeinLineItemCustomerResponse */
export type UpdateTradeinLineItemCustomerResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** accepted / returned / collected */
  customerResponse: Scalars['String']['input'];
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTradeinLineItemCustomerResponse. */
export type UpdateTradeinLineItemCustomerResponsePayload = {
  __typename?: 'UpdateTradeinLineItemCustomerResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

/** Autogenerated input type of UpdateTradeinLineItemEligibility */
export type UpdateTradeinLineItemEligibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 下取り可否（possible / not_possible） */
  eligibility?: InputMaybe<Scalars['String']['input']>;
  /** 特記事項 */
  note?: InputMaybe<Scalars['String']['input']>;
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTradeinLineItemEligibility. */
export type UpdateTradeinLineItemEligibilityPayload = {
  __typename?: 'UpdateTradeinLineItemEligibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

/** Autogenerated input type of UpdateTradeinLineItemReturnedShipping */
export type UpdateTradeinLineItemReturnedShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 返品発送日 */
  returnedShippedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** 返品追跡番号 */
  returnedTrackingCode?: InputMaybe<Scalars['String']['input']>;
  /** TradeinLineItem の UUID */
  uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTradeinLineItemReturnedShipping. */
export type UpdateTradeinLineItemReturnedShippingPayload = {
  __typename?: 'UpdateTradeinLineItemReturnedShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradeinLineItem?: Maybe<TradeinLineItem>;
};

/** Autogenerated return type of UpdateTradein. */
export type UpdateTradeinPayload = {
  __typename?: 'UpdateTradeinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  tradein?: Maybe<Tradein>;
};

/** Autogenerated input type of UpdateUserNewsletterStatus */
export type UpdateUserNewsletterStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  userUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserNewsletterStatus. */
export type UpdateUserNewsletterStatusPayload = {
  __typename?: 'UpdateUserNewsletterStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Address>>;
  birthday?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['ID']['output']>;
  cartReminderSubscribed: Scalars['Boolean']['output'];
  confirmationToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crossPointIdCg?: Maybe<Scalars['String']['output']>;
  dsUserIdCg?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameKana?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameKana?: Maybe<Scalars['String']['output']>;
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  likedListings?: Maybe<Array<Listing>>;
  newsletterStatus: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  orders?: Maybe<Array<Order>>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  payment?: Maybe<Payment>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  purchasedItemCount: Scalars['Int']['output'];
  recentViewedListings?: Maybe<Array<Listing>>;
  recentViewedProducts?: Maybe<Array<Product>>;
  role: Scalars['String']['output'];
  roleI18n?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['Int']['output']>;
  shopifyCustomerId?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  totalLikedListings?: Maybe<Scalars['Int']['output']>;
  totalPurchaseAmount: Scalars['Int']['output'];
  totalRecentViewedListings?: Maybe<Scalars['Int']['output']>;
  totalRecentViewedProducts?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};


export type UserLikedListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type UserRecentViewedListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type UserRecentViewedProductsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInput = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

export type UserSearchInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newsletterStatus?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type Users = {
  __typename?: 'Users';
  pagination: Pagination;
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

/** Autogenerated input type of VerifyAmazonPayment */
export type VerifyAmazonPaymentInput = {
  brandId: Scalars['ID']['input'];
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of VerifyAmazonPayment. */
export type VerifyAmazonPaymentPayload = {
  __typename?: 'VerifyAmazonPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** 確定した注文の UUID（完了ページで注文を取り直すため） */
  orderUuid?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VerifyCard */
export type VerifyCardInput = {
  accessId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VerifyCard. */
export type VerifyCardPayload = {
  __typename?: 'VerifyCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VerifyPayment */
export type VerifyPaymentInput = {
  accessId: Scalars['String']['input'];
  brandId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VerifyPayment. */
export type VerifyPaymentPayload = {
  __typename?: 'VerifyPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** 確定した注文の UUID（完了ページで注文を取り直すため） */
  orderUuid?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddressFragmentFragment = { __typename?: 'Address', id: string, uuid: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip: string, prefecture: string, prefectureI18n: string, city: string, street: string, tel: string, building?: string | null, isPrimary: boolean, fullAddress?: string | null, fullName?: string | null, fullNameKana?: string | null };

export type BrandFragmentFragment = { __typename?: 'Brand', id: string, name: string };

export type CampaignFragmentFragment = { __typename?: 'Campaign', id: string, uuid: string, code?: string | null, name: string, discountType: string, discountValue: number };

export type CategoryFragmentFragment = { __typename?: 'Category', id: string, uuid: string, name: string };

export type ColorFragmentFragment = { __typename?: 'Color', id: string, name: string, colorImage?: string | null };

export type ConditionFragmentFragment = { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null };

export type ContactFragmentFragment = { __typename?: 'Contact', id: string, uuid: string, lastName?: string | null, firstName?: string | null, name?: string | null, email?: string | null, tel?: string | null, message?: string | null };

export type EventReservationFragmentFragment = { __typename?: 'EventReservation', id: string, uuid: string, lastName: string, firstName: string, lastNameKana?: string | null, firstNameKana?: string | null, email: string, phoneNumber?: string | null, itemCount?: number | null, attendeeCount: number, reservedDate: any };

export type ImageFragmentFragment = { __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string };

export type ItemFragmentFragment = { __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null };

export type LikeFragmentFragment = { __typename?: 'Like', id?: string | null, uuid?: string | null };

export type ListingFragmentFragment = { __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean };

export type NewsletterSubscriberFragmentFragment = { __typename?: 'NewsletterSubscriber', id: string, email: string, status: string, subscribedAt?: any | null, unsubscribedAt?: any | null, createdAt: any, updatedAt: any, isGuest: boolean, isSubscribed: boolean };

export type OrderFragmentFragment = { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null };

export type OrderPurchaseFragmentFragment = { __typename?: 'OrderPurchase', orderNumber?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null };

export type OrganizationFragmentFragment = { __typename?: 'Organization', id: string, name: string };

export type PaginationFragmentFragment = { __typename?: 'Pagination', resultsCount: number, totalCount: number, totalPages: number, currentPage: number, currentCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean };

export type PaymentFragmentFragment = { __typename?: 'Payment', id: string, uuid: string, userId: string, paymentToken?: string | null, toBeExpiredAt?: string | null, maskedCardNo?: string | null, isSecurityCodeSet?: string | null, cardId?: string | null, memberId?: string | null, cardBrand?: string | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null };

export type ProductMasterFragmentFragment = { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null };

export type ShippingAddressFragmentFragment = { __typename?: 'ShippingAddress', id: string, uuid: string, orderId: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip?: string | null, prefecture?: string | null, prefectureI18n?: string | null, city?: string | null, street?: string | null, tel?: string | null, building?: string | null };

export type SizeFragmentFragment = { __typename?: 'Size', id: string, name: string, position: number };

export type SizeGuideFragmentFragment = { __typename?: 'SizeGuide', id: string, chestWidth?: string | null, headCircumference?: string | null, height?: string | null, length?: string | null, shoulderWidth?: string | null, sleeveLength?: string | null, uuid: string, productMasterId: string, sizeId: string };

export type TradeinFragmentFragment = { __typename?: 'Tradein', id: string, uuid: string, lastName: string, firstName: string, lastNameKana: string, firstNameKana: string, email: string, tel: string, zip: string, prefecture: string, prefectureI18n: string, city: string, street?: string | null, building?: string | null, birthday?: string | null, status: string, statusI18n?: string | null, repairMethod: string, repairMethodI18n?: string | null, occupation?: string | null, occupationI18n?: string | null, identificationType?: string | null, identificationTypeI18n?: string | null };

export type UserFragmentFragment = { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null };

export type CreateAddressMutationVariables = Exact<{
  attributes: AddressAttributes;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'CreateAddressPayload', error?: string | null, address?: { __typename?: 'Address', id: string, uuid: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip: string, prefecture: string, prefectureI18n: string, city: string, street: string, tel: string, building?: string | null, isPrimary: boolean, fullAddress?: string | null, fullName?: string | null, fullNameKana?: string | null } | null } };

export type DeleteAddressMutationVariables = Exact<{
  input: DeleteAddressInput;
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteAddress: { __typename?: 'DeleteAddressPayload', success: boolean, error?: string | null } };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'UpdateAddressPayload', error?: string | null, address?: { __typename?: 'Address', id: string, uuid: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip: string, prefecture: string, prefectureI18n: string, city: string, street: string, tel: string, building?: string | null, isPrimary: boolean, fullAddress?: string | null, fullName?: string | null, fullNameKana?: string | null } | null } };

export type UpdatePrimaryAddressMutationVariables = Exact<{
  input: UpdatePrimaryAddressInput;
}>;


export type UpdatePrimaryAddressMutation = { __typename?: 'Mutation', updatePrimaryAddress: { __typename?: 'UpdatePrimaryAddressPayload', success: boolean, error?: string | null } };

export type CreateAmazonPayCheckoutPayloadMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
}>;


export type CreateAmazonPayCheckoutPayloadMutation = { __typename?: 'Mutation', createAmazonPayCheckoutPayload: { __typename?: 'CreateCheckoutPayloadPayload', payloadJson?: string | null, signature?: string | null, merchantId?: string | null, publicKeyId?: string | null, sandbox?: boolean | null, error?: string | null } };

export type VerifyAmazonPaymentMutationVariables = Exact<{
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['ID']['input'];
  orderUuid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type VerifyAmazonPaymentMutation = { __typename?: 'Mutation', verifyAmazonPayment: { __typename?: 'VerifyAmazonPaymentPayload', success: boolean, error?: string | null, redirectUrl?: string | null, orderUuid?: string | null } };

export type GeneratePresignedUrlMutationVariables = Exact<{
  input: GeneratePresignedUrlInput;
}>;


export type GeneratePresignedUrlMutation = { __typename?: 'Mutation', generatePresignedUrl: { __typename?: 'GeneratePresignedUrlPayload', presignUrl?: string | null, keyName?: string | null, error?: string | null } };

export type SigninMutationVariables = Exact<{
  brandId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SigninMutation = { __typename?: 'Mutation', signin: { __typename?: 'SigninPayload', error?: string | null, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | null, addresses?: Array<{ __typename?: 'Address', id: string, uuid: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip: string, prefecture: string, prefectureI18n: string, city: string, street: string, tel: string, building?: string | null, isPrimary: boolean, fullAddress?: string | null, fullName?: string | null, fullNameKana?: string | null }> | null } | null } };

export type SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignoutMutation = { __typename?: 'Mutation', signout: { __typename?: 'SignoutPayload', result?: string | null } };

export type UnsubscribeCartReminderByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UnsubscribeCartReminderByTokenMutation = { __typename?: 'Mutation', unsubscribeCartReminderByToken: { __typename?: 'UnsubscribeCartReminderByTokenPayload', success: boolean, message?: string | null, errors?: Array<string> | null } };

export type UpdateCartReminderSubscriptionMutationVariables = Exact<{
  subscribed: Scalars['Boolean']['input'];
}>;


export type UpdateCartReminderSubscriptionMutation = { __typename?: 'Mutation', updateCartReminderSubscription: { __typename?: 'UpdateCartReminderSubscriptionPayload', subscribed?: boolean | null, success: boolean, message?: string | null, errors?: Array<string> | null } };

export type CreateContactMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  attributes: ContactAttributes;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'CreateContactPayload', error?: string | null, contact?: { __typename?: 'Contact', id: string, uuid: string, lastName?: string | null, firstName?: string | null, name?: string | null, email?: string | null, tel?: string | null, message?: string | null } | null } };

export type CreateEventReservationMutationVariables = Exact<{
  attributes: EventReservationInput;
}>;


export type CreateEventReservationMutation = { __typename?: 'Mutation', createEventReservation: { __typename?: 'CreateEventReservationPayload', error?: string | null, eventReservation?: { __typename?: 'EventReservation', id: string, uuid: string, lastName: string, firstName: string, lastNameKana?: string | null, firstNameKana?: string | null, email: string, phoneNumber?: string | null, itemCount?: number | null, attendeeCount: number, reservedDate: any } | null } };

export type VerifyCardMutationVariables = Exact<{
  accessId: Scalars['String']['input'];
}>;


export type VerifyCardMutation = { __typename?: 'Mutation', verifyCard: { __typename?: 'VerifyCardPayload', success: boolean, error?: string | null } };

export type VerifyPaymentMutationVariables = Exact<{
  accessId: Scalars['String']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type VerifyPaymentMutation = { __typename?: 'Mutation', verifyPayment: { __typename?: 'VerifyPaymentPayload', success: boolean, error?: string | null, orderUuid?: string | null } };

export type CreateLikeMutationVariables = Exact<{
  attributes: LikeAttributes;
}>;


export type CreateLikeMutation = { __typename?: 'Mutation', createLike: { __typename?: 'CreateLikePayload', error?: string | null, like?: { __typename?: 'Like', id?: string | null, uuid?: string | null } | null } };

export type DeleteLikeMutationVariables = Exact<{
  attributes: LikeAttributes;
}>;


export type DeleteLikeMutation = { __typename?: 'Mutation', deleteLike: { __typename?: 'DeleteLikePayload', error?: string | null, like?: { __typename?: 'Like', id?: string | null, uuid?: string | null } | null } };

export type SubscribeNewsletterMutationVariables = Exact<{
  brandUuid: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type SubscribeNewsletterMutation = { __typename?: 'Mutation', subscribeNewsletter: { __typename?: 'SubscribeNewsletterPayload', success: boolean, message?: string | null, errors?: Array<string> | null, newsletterSubscriber?: { __typename?: 'NewsletterSubscriber', id: string, email: string, status: string, subscribedAt?: any | null, unsubscribedAt?: any | null, createdAt: any, updatedAt: any, isGuest: boolean, isSubscribed: boolean, brand: { __typename?: 'Brand', id: string, name: string }, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null } | null } | null } };

export type UnsubscribeNewsletterMutationVariables = Exact<{
  brandUuid: Scalars['ID']['input'];
}>;


export type UnsubscribeNewsletterMutation = { __typename?: 'Mutation', unsubscribeNewsletter: { __typename?: 'UnsubscribeNewsletterPayload', success: boolean, message?: string | null, errors?: Array<string> | null, newsletterSubscriber?: { __typename?: 'NewsletterSubscriber', id: string, email: string, status: string, subscribedAt?: any | null, unsubscribedAt?: any | null, createdAt: any, updatedAt: any, isGuest: boolean, isSubscribed: boolean, brand: { __typename?: 'Brand', id: string, name: string }, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null } | null } | null } };

export type UnsubscribeNewsletterByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UnsubscribeNewsletterByTokenMutation = { __typename?: 'Mutation', unsubscribeNewsletterByToken: { __typename?: 'UnsubscribeNewsletterByTokenPayload', success: boolean, message?: string | null, errors?: Array<string> | null } };

export type AddItemMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  listingUuid: Scalars['ID']['input'];
}>;


export type AddItemMutation = { __typename?: 'Mutation', addItem: { __typename?: 'AddItemPayload', error?: string | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type ConfirmMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  shippingAddressAttributes: ShippingAddressAttributes;
  paymentAttributes?: InputMaybe<PaymentAttributes>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  amazonCheckoutSessionId?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<OrderAttributionAttributes>;
}>;


export type ConfirmMutation = { __typename?: 'Mutation', confirm: { __typename?: 'ConfirmPayload', error?: string | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type GuestCheckoutMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
}>;


export type GuestCheckoutMutation = { __typename?: 'Mutation', guestCheckout: { __typename?: 'GuestCheckoutPayload', redirectUrl?: string | null, error?: string | null, success?: boolean | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type GuestConfirmMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  guestEmail: Scalars['String']['input'];
  guestTel: Scalars['String']['input'];
  shippingAddressAttributes: ShippingAddressAttributes;
  paymentAttributes?: InputMaybe<PaymentAttributes>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  amazonCheckoutSessionId?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<OrderAttributionAttributes>;
}>;


export type GuestConfirmMutation = { __typename?: 'Mutation', guestConfirm: { __typename?: 'GuestConfirmPayload', error?: string | null, success?: boolean | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type OrderMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
}>;


export type OrderMutation = { __typename?: 'Mutation', order: { __typename?: 'OrderPayload', redirectUrl?: string | null, error?: string | null, requiresCardReregistration?: boolean | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type RemoveItemMutationVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  listingUuid: Scalars['ID']['input'];
}>;


export type RemoveItemMutation = { __typename?: 'Mutation', removeItem: { __typename?: 'RemoveItemPayload', error?: string | null, order?: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null }> | null } | null } };

export type DeletePaymentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'DeletePaymentPayload', error?: string | null, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null } | null } };

export type UpdatePaymentMutationVariables = Exact<{
  paymentAttributes: PaymentAttributes;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'UpdatePaymentPayload', redirectUrl?: string | null, error?: string | null } };

export type CreateTradeinMutationVariables = Exact<{
  subdomain: Scalars['String']['input'];
  attributes: TradeinAttributes;
}>;


export type CreateTradeinMutation = { __typename?: 'Mutation', createTradein: { __typename?: 'CreateTradeinPayload', error?: string | null, tradein?: { __typename?: 'Tradein', id: string, uuid: string, lastName: string, firstName: string, lastNameKana: string, firstNameKana: string, email: string, tel: string, zip: string, prefecture: string, prefectureI18n: string, city: string, street?: string | null, building?: string | null, birthday?: string | null, status: string, statusI18n?: string | null, repairMethod: string, repairMethodI18n?: string | null, occupation?: string | null, occupationI18n?: string | null, identificationType?: string | null, identificationTypeI18n?: string | null } | null } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UpdateProfilePayload', error?: string | null, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null } | null } };

export type AmazonPayCheckoutSessionInfoQueryVariables = Exact<{
  checkoutSessionId: Scalars['String']['input'];
}>;


export type AmazonPayCheckoutSessionInfoQuery = { __typename?: 'Query', amazonPayCheckoutSessionInfo: { __typename?: 'AmazonPaySessionInfo', checkoutSessionId: string, paymentDescriptor?: string | null, buyerName?: string | null, buyerEmail?: string | null, status?: string | null } };

export type BrandQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type BrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, conditions?: Array<{ __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null }> | null } | null };

export type CategoriesQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, uuid: string, name: string }> };

export type EventReservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventReservationsQuery = { __typename?: 'Query', eventReservations: Array<{ __typename?: 'EventReservation', id: string, uuid: string, lastName: string, firstName: string, lastNameKana?: string | null, firstNameKana?: string | null, email: string, phoneNumber?: string | null, itemCount?: number | null, attendeeCount: number, reservedDate: any }> };

export type ListingQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ListingQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', isLiked: boolean, likeCount?: number | null, id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null, sizeGuides?: Array<{ __typename?: 'SizeGuide', id: string, chestWidth?: string | null, headCircumference?: string | null, height?: string | null, length?: string | null, shoulderWidth?: string | null, sleeveLength?: string | null, uuid: string, productMasterId: string, sizeId: string, size?: { __typename?: 'Size', id: string, name: string, position: number } | null }> | null, categories?: Array<{ __typename?: 'Category', id: string, uuid: string, name: string }> | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null } | null };

export type ListingsQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListingSearch>;
}>;


export type ListingsQuery = { __typename?: 'Query', listings: { __typename?: 'Listings', totalCount: number, listings: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null }>, pagination: { __typename?: 'Pagination', resultsCount: number, totalCount: number, totalPages: number, currentPage: number, currentCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RecommendedListingsQueryVariables = Exact<{
  listingUuid: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecommendedListingsQuery = { __typename?: 'Query', recommendedListings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null } }> | null };

export type NewsletterSubscriptionQueryVariables = Exact<{
  brandUuid: Scalars['ID']['input'];
}>;


export type NewsletterSubscriptionQuery = { __typename?: 'Query', newsletterSubscription?: { __typename?: 'NewsletterSubscriber', id: string, email: string, status: string, subscribedAt?: any | null, unsubscribedAt?: any | null, createdAt: any, updatedAt: any, isGuest: boolean, isSubscribed: boolean, brand: { __typename?: 'Brand', id: string, name: string }, user?: { __typename?: 'User', id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null } | null } | null };

export type CompletedOrderQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type CompletedOrderQuery = { __typename?: 'Query', completedOrder?: { __typename?: 'OrderPurchase', orderNumber?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null, listing: { __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null } }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null } }> | null } | null };

export type CurrentOrderQueryVariables = Exact<{
  brandUuid: Scalars['ID']['input'];
}>;


export type CurrentOrderQuery = { __typename?: 'Query', currentOrder: { __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null, listing: { __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null } }> | null, shippingAddress?: { __typename?: 'ShippingAddress', id: string, uuid: string, orderId: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip?: string | null, prefecture?: string | null, prefectureI18n?: string | null, city?: string | null, street?: string | null, tel?: string | null, building?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, uuid: string, code?: string | null, name: string, discountType: string, discountValue: number } | null } };

export type MyOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MyOrdersQuery = { __typename?: 'Query', myOrders: { __typename?: 'Orders', orders: Array<{ __typename?: 'Order', id: string, uuid: string, brandId: string, orderNumber?: number | null, orderDate?: any | null, totalPrice?: number | null, itemTotalPrice?: number | null, shippingTotalPrice?: number | null, status?: string | null, statusI18n?: string | null, paymentStatus?: string | null, paymentStatusI18n?: string | null, shippingStatus?: string | null, shippingStatusI18n?: string | null, discountAmount?: number | null, guestEmail?: string | null, guestTel?: string | null, guestPaymentMaskedCard?: string | null, paymentMethod?: PaymentMethod | null, items?: Array<{ __typename?: 'Item', id: string, uuid: string, orderId: string, listingId: string, price?: number | null, listing: { __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null } }> | null }>, pagination: { __typename?: 'Pagination', resultsCount: number, totalCount: number, totalPages: number, currentPage: number, currentCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type BrandProductMasterListQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type BrandProductMasterListQuery = { __typename?: 'Query', brandProductMasterList: Array<{ __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }> };

export type BrandProductSearchQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  search?: InputMaybe<ProductSearch>;
}>;


export type BrandProductSearchQuery = { __typename?: 'Query', brandProductSearch: { __typename?: 'Products', products: Array<{ __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null }> } };

export type ProductQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null, sizeGuides?: Array<{ __typename?: 'SizeGuide', id: string, chestWidth?: string | null, headCircumference?: string | null, height?: string | null, length?: string | null, shoulderWidth?: string | null, sleeveLength?: string | null, uuid: string, productMasterId: string, sizeId: string, size?: { __typename?: 'Size', id: string, name: string, position: number } | null }> | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null, categories?: Array<{ __typename?: 'Category', id: string, uuid: string, name: string }> | null }, brand?: { __typename?: 'Brand', id: string, name: string, tradeInConditions?: Array<{ __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null }> | null } | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null, listings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, size?: { __typename?: 'Size', id: string, name: string, position: number } | null }> | null, salesListings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, size?: { __typename?: 'Size', id: string, name: string, position: number } | null }> | null } | null };

export type ProductsQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProductSearch>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'Products', totalCount: number, products: Array<{ __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null }, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null, listings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean }> | null }>, pagination: { __typename?: 'Pagination', resultsCount: number, totalCount: number, totalPages: number, currentPage: number, currentCount: number, nextPage?: number | null, previousPage?: number | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ListingSizesQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type ListingSizesQuery = { __typename?: 'Query', listingSizes: Array<{ __typename?: 'Size', id: string, name: string, position: number }> };

export type SizesQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type SizesQuery = { __typename?: 'Query', sizes: Array<{ __typename?: 'Size', id: string, name: string, position: number }> };

export type CurrentUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  likedPage?: InputMaybe<Scalars['Int']['input']>;
  likedPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', cartReminderSubscribed: boolean, totalRecentViewedProducts?: number | null, totalRecentViewedListings?: number | null, totalLikedListings?: number | null, id: string, email: string, role: string, firstName?: string | null, lastName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, confirmationToken?: string | null, fullName?: string | null, organizationId?: string | null, paymentToken?: string | null, sex?: number | null, tel?: string | null, birthday?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | null, payment?: { __typename?: 'Payment', id: string, uuid: string, userId: string, paymentToken?: string | null, toBeExpiredAt?: string | null, maskedCardNo?: string | null, isSecurityCodeSet?: string | null, cardId?: string | null, memberId?: string | null, cardBrand?: string | null } | null, addresses?: Array<{ __typename?: 'Address', id: string, uuid: string, lastName?: string | null, firstName?: string | null, lastNameKana?: string | null, firstNameKana?: string | null, zip: string, prefecture: string, prefectureI18n: string, city: string, street: string, tel: string, building?: string | null, isPrimary: boolean, fullAddress?: string | null, fullName?: string | null, fullNameKana?: string | null }> | null, recentViewedProducts?: Array<{ __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null }, salesListings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean }> | null, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, sizes?: Array<{ __typename?: 'Size', id: string, name: string, position: number }> | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null }> | null, recentViewedListings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null }> | null, likedListings?: Array<{ __typename?: 'Listing', id: string, uuid: string, organizationId: string, brandId: string, sellerId: string, productId: string, conditionId?: string | null, sizeId?: string | null, status: string, statusI18n: string, repairMethod?: string | null, repairMethodI18n?: string | null, comment?: string | null, price?: number | null, conditionText?: string | null, isLiked: boolean, likeCount?: number | null, isSoldOut: boolean, product: { __typename?: 'Product', id: string, uuid: string, status: string, isResale: boolean, isArchive: boolean, isSoldOut: boolean, colorId?: string | null, styleColor?: string | null, productMaster: { __typename?: 'ProductMaster', id: string, uuid: string, brandId: string, name: string, code?: string | null, description?: string | null, price?: number | null, priceTotal?: number | null, care?: string | null, sex?: string | null, sexI18n?: string | null, year?: string | null, sizeGuide?: string | null, material?: string | null, tradeinPrice?: number | null, detailDescription?: string | null, fit?: string | null, lengthType?: string | null, fill?: string | null, hood?: string | null }, color?: { __typename?: 'Color', id: string, name: string, colorImage?: string | null } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null }, size?: { __typename?: 'Size', id: string, name: string, position: number } | null, images?: Array<{ __typename?: 'Image', id: string, resourceId?: string | null, resourceType?: string | null, image: string, imageUrl: string }> | null, condition?: { __typename?: 'Condition', id: string, uuid: string, name?: string | null, tradeInRate?: number | null, resaleRate?: number | null } | null }> | null } | null };

export const AddressFragmentFragmentDoc = gql`
    fragment addressFragment on Address {
  id
  uuid
  lastName
  firstName
  lastNameKana
  firstNameKana
  zip
  prefecture
  prefectureI18n
  city
  street
  tel
  building
  isPrimary
  fullAddress
  fullName
  fullNameKana
}
    `;
export const BrandFragmentFragmentDoc = gql`
    fragment brandFragment on Brand {
  id
  name
}
    `;
export const CampaignFragmentFragmentDoc = gql`
    fragment campaignFragment on Campaign {
  id
  uuid
  code
  name
  discountType
  discountValue
}
    `;
export const CategoryFragmentFragmentDoc = gql`
    fragment categoryFragment on Category {
  id
  uuid
  name
}
    `;
export const ColorFragmentFragmentDoc = gql`
    fragment colorFragment on Color {
  id
  name
  colorImage
}
    `;
export const ConditionFragmentFragmentDoc = gql`
    fragment conditionFragment on Condition {
  id
  uuid
  name
  tradeInRate
  resaleRate
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment contactFragment on Contact {
  id
  uuid
  lastName
  firstName
  name
  email
  tel
  message
}
    `;
export const EventReservationFragmentFragmentDoc = gql`
    fragment eventReservationFragment on EventReservation {
  id
  uuid
  lastName
  firstName
  lastNameKana
  firstNameKana
  email
  phoneNumber
  itemCount
  attendeeCount
  reservedDate
}
    `;
export const ImageFragmentFragmentDoc = gql`
    fragment imageFragment on Image {
  id
  resourceId
  resourceType
  image
  imageUrl
}
    `;
export const ItemFragmentFragmentDoc = gql`
    fragment itemFragment on Item {
  id
  uuid
  orderId
  listingId
  price
}
    `;
export const LikeFragmentFragmentDoc = gql`
    fragment likeFragment on Like {
  id
  uuid
}
    `;
export const ListingFragmentFragmentDoc = gql`
    fragment listingFragment on Listing {
  id
  uuid
  organizationId
  brandId
  sellerId
  productId
  conditionId
  sizeId
  status
  statusI18n
  repairMethod
  repairMethodI18n
  comment
  price
  conditionText
  isLiked
  likeCount
  isSoldOut
}
    `;
export const NewsletterSubscriberFragmentFragmentDoc = gql`
    fragment newsletterSubscriberFragment on NewsletterSubscriber {
  id
  email
  status
  subscribedAt
  unsubscribedAt
  createdAt
  updatedAt
  isGuest
  isSubscribed
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment orderFragment on Order {
  id
  uuid
  brandId
  orderNumber
  orderDate
  totalPrice
  itemTotalPrice
  shippingTotalPrice
  status
  statusI18n
  paymentStatus
  paymentStatusI18n
  shippingStatus
  shippingStatusI18n
  discountAmount
  guestEmail
  guestTel
  guestPaymentMaskedCard
  paymentMethod
}
    `;
export const OrderPurchaseFragmentFragmentDoc = gql`
    fragment orderPurchaseFragment on OrderPurchase {
  orderNumber
  itemTotalPrice
  shippingTotalPrice
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment organizationFragment on Organization {
  id
  name
}
    `;
export const PaginationFragmentFragmentDoc = gql`
    fragment paginationFragment on Pagination {
  resultsCount
  totalCount
  totalPages
  currentPage
  currentCount
  nextPage
  previousPage
  hasNextPage
  hasPreviousPage
}
    `;
export const PaymentFragmentFragmentDoc = gql`
    fragment paymentFragment on Payment {
  id
  uuid
  userId
  paymentToken
  toBeExpiredAt
  maskedCardNo
  isSecurityCodeSet
  cardId
  memberId
  cardBrand
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment productFragment on Product {
  id
  uuid
  status
  isResale
  isArchive
  isSoldOut
  colorId
  styleColor
}
    `;
export const ProductMasterFragmentFragmentDoc = gql`
    fragment productMasterFragment on ProductMaster {
  id
  uuid
  brandId
  name
  code
  description
  price
  priceTotal
  care
  sex
  sexI18n
  year
  sizeGuide
  material
  tradeinPrice
  detailDescription
  fit
  lengthType
  fill
  hood
}
    `;
export const ShippingAddressFragmentFragmentDoc = gql`
    fragment shippingAddressFragment on ShippingAddress {
  id
  uuid
  orderId
  lastName
  firstName
  lastNameKana
  firstNameKana
  zip
  prefecture
  prefectureI18n
  city
  street
  tel
  building
}
    `;
export const SizeFragmentFragmentDoc = gql`
    fragment sizeFragment on Size {
  id
  name
  position
}
    `;
export const SizeGuideFragmentFragmentDoc = gql`
    fragment sizeGuideFragment on SizeGuide {
  id
  chestWidth
  headCircumference
  height
  length
  shoulderWidth
  sleeveLength
  uuid
  productMasterId
  sizeId
}
    `;
export const TradeinFragmentFragmentDoc = gql`
    fragment tradeinFragment on Tradein {
  id
  uuid
  lastName
  firstName
  lastNameKana
  firstNameKana
  email
  tel
  zip
  prefecture
  prefectureI18n
  city
  street
  building
  birthday
  status
  statusI18n
  repairMethod
  repairMethodI18n
  occupation
  occupationI18n
  identificationType
  identificationTypeI18n
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment userFragment on User {
  id
  email
  role
  firstName
  lastName
  lastNameKana
  firstNameKana
  confirmationToken
  fullName
  organizationId
  paymentToken
  sex
  tel
  birthday
}
    `;
export const CreateAddressDocument = gql`
    mutation createAddress($attributes: AddressAttributes!) {
  createAddress(input: {attributes: $attributes}) {
    address {
      ...addressFragment
    }
    error
  }
}
    ${AddressFragmentFragmentDoc}`;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($input: DeleteAddressInput!) {
  deleteAddress(input: $input) {
    success
    error
  }
}
    `;
export type DeleteAddressMutationFn = Apollo.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($input: UpdateAddressInput!) {
  updateAddress(input: $input) {
    address {
      ...addressFragment
    }
    error
  }
}
    ${AddressFragmentFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdatePrimaryAddressDocument = gql`
    mutation UpdatePrimaryAddress($input: UpdatePrimaryAddressInput!) {
  updatePrimaryAddress(input: $input) {
    success
    error
  }
}
    `;
export type UpdatePrimaryAddressMutationFn = Apollo.MutationFunction<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>;

/**
 * __useUpdatePrimaryAddressMutation__
 *
 * To run a mutation, you first call `useUpdatePrimaryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimaryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimaryAddressMutation, { data, loading, error }] = useUpdatePrimaryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrimaryAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>(UpdatePrimaryAddressDocument, options);
      }
export type UpdatePrimaryAddressMutationHookResult = ReturnType<typeof useUpdatePrimaryAddressMutation>;
export type UpdatePrimaryAddressMutationResult = Apollo.MutationResult<UpdatePrimaryAddressMutation>;
export type UpdatePrimaryAddressMutationOptions = Apollo.BaseMutationOptions<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>;
export const CreateAmazonPayCheckoutPayloadDocument = gql`
    mutation CreateAmazonPayCheckoutPayload($orderUuid: ID!) {
  createAmazonPayCheckoutPayload(input: {orderUuid: $orderUuid}) {
    payloadJson
    signature
    merchantId
    publicKeyId
    sandbox
    error
  }
}
    `;
export type CreateAmazonPayCheckoutPayloadMutationFn = Apollo.MutationFunction<CreateAmazonPayCheckoutPayloadMutation, CreateAmazonPayCheckoutPayloadMutationVariables>;

/**
 * __useCreateAmazonPayCheckoutPayloadMutation__
 *
 * To run a mutation, you first call `useCreateAmazonPayCheckoutPayloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmazonPayCheckoutPayloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmazonPayCheckoutPayloadMutation, { data, loading, error }] = useCreateAmazonPayCheckoutPayloadMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *   },
 * });
 */
export function useCreateAmazonPayCheckoutPayloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAmazonPayCheckoutPayloadMutation, CreateAmazonPayCheckoutPayloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAmazonPayCheckoutPayloadMutation, CreateAmazonPayCheckoutPayloadMutationVariables>(CreateAmazonPayCheckoutPayloadDocument, options);
      }
export type CreateAmazonPayCheckoutPayloadMutationHookResult = ReturnType<typeof useCreateAmazonPayCheckoutPayloadMutation>;
export type CreateAmazonPayCheckoutPayloadMutationResult = Apollo.MutationResult<CreateAmazonPayCheckoutPayloadMutation>;
export type CreateAmazonPayCheckoutPayloadMutationOptions = Apollo.BaseMutationOptions<CreateAmazonPayCheckoutPayloadMutation, CreateAmazonPayCheckoutPayloadMutationVariables>;
export const VerifyAmazonPaymentDocument = gql`
    mutation VerifyAmazonPayment($checkoutSessionId: String, $brandId: ID!, $orderUuid: ID) {
  verifyAmazonPayment(
    input: {checkoutSessionId: $checkoutSessionId, brandId: $brandId, orderUuid: $orderUuid}
  ) {
    success
    error
    redirectUrl
    orderUuid
  }
}
    `;
export type VerifyAmazonPaymentMutationFn = Apollo.MutationFunction<VerifyAmazonPaymentMutation, VerifyAmazonPaymentMutationVariables>;

/**
 * __useVerifyAmazonPaymentMutation__
 *
 * To run a mutation, you first call `useVerifyAmazonPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAmazonPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAmazonPaymentMutation, { data, loading, error }] = useVerifyAmazonPaymentMutation({
 *   variables: {
 *      checkoutSessionId: // value for 'checkoutSessionId'
 *      brandId: // value for 'brandId'
 *      orderUuid: // value for 'orderUuid'
 *   },
 * });
 */
export function useVerifyAmazonPaymentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAmazonPaymentMutation, VerifyAmazonPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAmazonPaymentMutation, VerifyAmazonPaymentMutationVariables>(VerifyAmazonPaymentDocument, options);
      }
export type VerifyAmazonPaymentMutationHookResult = ReturnType<typeof useVerifyAmazonPaymentMutation>;
export type VerifyAmazonPaymentMutationResult = Apollo.MutationResult<VerifyAmazonPaymentMutation>;
export type VerifyAmazonPaymentMutationOptions = Apollo.BaseMutationOptions<VerifyAmazonPaymentMutation, VerifyAmazonPaymentMutationVariables>;
export const GeneratePresignedUrlDocument = gql`
    mutation generatePresignedUrl($input: GeneratePresignedUrlInput!) {
  generatePresignedUrl(input: $input) {
    presignUrl
    keyName
    error
  }
}
    `;
export type GeneratePresignedUrlMutationFn = Apollo.MutationFunction<GeneratePresignedUrlMutation, GeneratePresignedUrlMutationVariables>;

/**
 * __useGeneratePresignedUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlMutation, { data, loading, error }] = useGeneratePresignedUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedUrlMutation, GeneratePresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedUrlMutation, GeneratePresignedUrlMutationVariables>(GeneratePresignedUrlDocument, options);
      }
export type GeneratePresignedUrlMutationHookResult = ReturnType<typeof useGeneratePresignedUrlMutation>;
export type GeneratePresignedUrlMutationResult = Apollo.MutationResult<GeneratePresignedUrlMutation>;
export type GeneratePresignedUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedUrlMutation, GeneratePresignedUrlMutationVariables>;
export const SigninDocument = gql`
    mutation signin($brandId: String!, $email: String!, $password: String!) {
  signin(input: {brandId: $brandId, email: $email, password: $password}) {
    user {
      ...userFragment
      organization {
        ...organizationFragment
        brands {
          ...brandFragment
        }
      }
      addresses {
        ...addressFragment
      }
    }
    error
  }
}
    ${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export type SigninMutationFn = Apollo.MutationFunction<SigninMutation, SigninMutationVariables>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSigninMutation(baseOptions?: Apollo.MutationHookOptions<SigninMutation, SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument, options);
      }
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<SigninMutation, SigninMutationVariables>;
export const SignoutDocument = gql`
    mutation signout {
  signout(input: {}) {
    result
  }
}
    `;
export type SignoutMutationFn = Apollo.MutationFunction<SignoutMutation, SignoutMutationVariables>;

/**
 * __useSignoutMutation__
 *
 * To run a mutation, you first call `useSignoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signoutMutation, { data, loading, error }] = useSignoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignoutMutation(baseOptions?: Apollo.MutationHookOptions<SignoutMutation, SignoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignoutMutation, SignoutMutationVariables>(SignoutDocument, options);
      }
export type SignoutMutationHookResult = ReturnType<typeof useSignoutMutation>;
export type SignoutMutationResult = Apollo.MutationResult<SignoutMutation>;
export type SignoutMutationOptions = Apollo.BaseMutationOptions<SignoutMutation, SignoutMutationVariables>;
export const UnsubscribeCartReminderByTokenDocument = gql`
    mutation unsubscribeCartReminderByToken($token: String!) {
  unsubscribeCartReminderByToken(input: {token: $token}) {
    success
    message
    errors
  }
}
    `;
export type UnsubscribeCartReminderByTokenMutationFn = Apollo.MutationFunction<UnsubscribeCartReminderByTokenMutation, UnsubscribeCartReminderByTokenMutationVariables>;

/**
 * __useUnsubscribeCartReminderByTokenMutation__
 *
 * To run a mutation, you first call `useUnsubscribeCartReminderByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeCartReminderByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeCartReminderByTokenMutation, { data, loading, error }] = useUnsubscribeCartReminderByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUnsubscribeCartReminderByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeCartReminderByTokenMutation, UnsubscribeCartReminderByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeCartReminderByTokenMutation, UnsubscribeCartReminderByTokenMutationVariables>(UnsubscribeCartReminderByTokenDocument, options);
      }
export type UnsubscribeCartReminderByTokenMutationHookResult = ReturnType<typeof useUnsubscribeCartReminderByTokenMutation>;
export type UnsubscribeCartReminderByTokenMutationResult = Apollo.MutationResult<UnsubscribeCartReminderByTokenMutation>;
export type UnsubscribeCartReminderByTokenMutationOptions = Apollo.BaseMutationOptions<UnsubscribeCartReminderByTokenMutation, UnsubscribeCartReminderByTokenMutationVariables>;
export const UpdateCartReminderSubscriptionDocument = gql`
    mutation updateCartReminderSubscription($subscribed: Boolean!) {
  updateCartReminderSubscription(input: {subscribed: $subscribed}) {
    subscribed
    success
    message
    errors
  }
}
    `;
export type UpdateCartReminderSubscriptionMutationFn = Apollo.MutationFunction<UpdateCartReminderSubscriptionMutation, UpdateCartReminderSubscriptionMutationVariables>;

/**
 * __useUpdateCartReminderSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCartReminderSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartReminderSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartReminderSubscriptionMutation, { data, loading, error }] = useUpdateCartReminderSubscriptionMutation({
 *   variables: {
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useUpdateCartReminderSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartReminderSubscriptionMutation, UpdateCartReminderSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartReminderSubscriptionMutation, UpdateCartReminderSubscriptionMutationVariables>(UpdateCartReminderSubscriptionDocument, options);
      }
export type UpdateCartReminderSubscriptionMutationHookResult = ReturnType<typeof useUpdateCartReminderSubscriptionMutation>;
export type UpdateCartReminderSubscriptionMutationResult = Apollo.MutationResult<UpdateCartReminderSubscriptionMutation>;
export type UpdateCartReminderSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateCartReminderSubscriptionMutation, UpdateCartReminderSubscriptionMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($uuid: ID!, $attributes: ContactAttributes!) {
  createContact(input: {uuid: $uuid, attributes: $attributes}) {
    contact {
      ...contactFragment
    }
    error
  }
}
    ${ContactFragmentFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateEventReservationDocument = gql`
    mutation createEventReservation($attributes: EventReservationInput!) {
  createEventReservation(input: {attributes: $attributes}) {
    eventReservation {
      ...eventReservationFragment
    }
    error
  }
}
    ${EventReservationFragmentFragmentDoc}`;
export type CreateEventReservationMutationFn = Apollo.MutationFunction<CreateEventReservationMutation, CreateEventReservationMutationVariables>;

/**
 * __useCreateEventReservationMutation__
 *
 * To run a mutation, you first call `useCreateEventReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventReservationMutation, { data, loading, error }] = useCreateEventReservationMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateEventReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventReservationMutation, CreateEventReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventReservationMutation, CreateEventReservationMutationVariables>(CreateEventReservationDocument, options);
      }
export type CreateEventReservationMutationHookResult = ReturnType<typeof useCreateEventReservationMutation>;
export type CreateEventReservationMutationResult = Apollo.MutationResult<CreateEventReservationMutation>;
export type CreateEventReservationMutationOptions = Apollo.BaseMutationOptions<CreateEventReservationMutation, CreateEventReservationMutationVariables>;
export const VerifyCardDocument = gql`
    mutation VerifyCard($accessId: String!) {
  verifyCard(input: {accessId: $accessId}) {
    success
    error
  }
}
    `;
export type VerifyCardMutationFn = Apollo.MutationFunction<VerifyCardMutation, VerifyCardMutationVariables>;

/**
 * __useVerifyCardMutation__
 *
 * To run a mutation, you first call `useVerifyCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCardMutation, { data, loading, error }] = useVerifyCardMutation({
 *   variables: {
 *      accessId: // value for 'accessId'
 *   },
 * });
 */
export function useVerifyCardMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCardMutation, VerifyCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCardMutation, VerifyCardMutationVariables>(VerifyCardDocument, options);
      }
export type VerifyCardMutationHookResult = ReturnType<typeof useVerifyCardMutation>;
export type VerifyCardMutationResult = Apollo.MutationResult<VerifyCardMutation>;
export type VerifyCardMutationOptions = Apollo.BaseMutationOptions<VerifyCardMutation, VerifyCardMutationVariables>;
export const VerifyPaymentDocument = gql`
    mutation VerifyPayment($accessId: String!, $brandId: ID!) {
  verifyPayment(input: {accessId: $accessId, brandId: $brandId}) {
    success
    error
    orderUuid
  }
}
    `;
export type VerifyPaymentMutationFn = Apollo.MutationFunction<VerifyPaymentMutation, VerifyPaymentMutationVariables>;

/**
 * __useVerifyPaymentMutation__
 *
 * To run a mutation, you first call `useVerifyPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPaymentMutation, { data, loading, error }] = useVerifyPaymentMutation({
 *   variables: {
 *      accessId: // value for 'accessId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useVerifyPaymentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPaymentMutation, VerifyPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPaymentMutation, VerifyPaymentMutationVariables>(VerifyPaymentDocument, options);
      }
export type VerifyPaymentMutationHookResult = ReturnType<typeof useVerifyPaymentMutation>;
export type VerifyPaymentMutationResult = Apollo.MutationResult<VerifyPaymentMutation>;
export type VerifyPaymentMutationOptions = Apollo.BaseMutationOptions<VerifyPaymentMutation, VerifyPaymentMutationVariables>;
export const CreateLikeDocument = gql`
    mutation createLike($attributes: LikeAttributes!) {
  createLike(input: {attributes: $attributes}) {
    like {
      ...likeFragment
    }
    error
  }
}
    ${LikeFragmentFragmentDoc}`;
export type CreateLikeMutationFn = Apollo.MutationFunction<CreateLikeMutation, CreateLikeMutationVariables>;

/**
 * __useCreateLikeMutation__
 *
 * To run a mutation, you first call `useCreateLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLikeMutation, { data, loading, error }] = useCreateLikeMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateLikeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLikeMutation, CreateLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLikeMutation, CreateLikeMutationVariables>(CreateLikeDocument, options);
      }
export type CreateLikeMutationHookResult = ReturnType<typeof useCreateLikeMutation>;
export type CreateLikeMutationResult = Apollo.MutationResult<CreateLikeMutation>;
export type CreateLikeMutationOptions = Apollo.BaseMutationOptions<CreateLikeMutation, CreateLikeMutationVariables>;
export const DeleteLikeDocument = gql`
    mutation deleteLike($attributes: LikeAttributes!) {
  deleteLike(input: {attributes: $attributes}) {
    like {
      ...likeFragment
    }
    error
  }
}
    ${LikeFragmentFragmentDoc}`;
export type DeleteLikeMutationFn = Apollo.MutationFunction<DeleteLikeMutation, DeleteLikeMutationVariables>;

/**
 * __useDeleteLikeMutation__
 *
 * To run a mutation, you first call `useDeleteLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLikeMutation, { data, loading, error }] = useDeleteLikeMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteLikeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLikeMutation, DeleteLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLikeMutation, DeleteLikeMutationVariables>(DeleteLikeDocument, options);
      }
export type DeleteLikeMutationHookResult = ReturnType<typeof useDeleteLikeMutation>;
export type DeleteLikeMutationResult = Apollo.MutationResult<DeleteLikeMutation>;
export type DeleteLikeMutationOptions = Apollo.BaseMutationOptions<DeleteLikeMutation, DeleteLikeMutationVariables>;
export const SubscribeNewsletterDocument = gql`
    mutation subscribeNewsletter($brandUuid: ID!, $email: String!) {
  subscribeNewsletter(input: {brandUuid: $brandUuid, email: $email}) {
    newsletterSubscriber {
      ...newsletterSubscriberFragment
      brand {
        ...brandFragment
      }
      user {
        ...userFragment
      }
    }
    success
    message
    errors
  }
}
    ${NewsletterSubscriberFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type SubscribeNewsletterMutationFn = Apollo.MutationFunction<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>;

/**
 * __useSubscribeNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeNewsletterMutation, { data, loading, error }] = useSubscribeNewsletterMutation({
 *   variables: {
 *      brandUuid: // value for 'brandUuid'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSubscribeNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>(SubscribeNewsletterDocument, options);
      }
export type SubscribeNewsletterMutationHookResult = ReturnType<typeof useSubscribeNewsletterMutation>;
export type SubscribeNewsletterMutationResult = Apollo.MutationResult<SubscribeNewsletterMutation>;
export type SubscribeNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>;
export const UnsubscribeNewsletterDocument = gql`
    mutation unsubscribeNewsletter($brandUuid: ID!) {
  unsubscribeNewsletter(input: {brandUuid: $brandUuid}) {
    newsletterSubscriber {
      ...newsletterSubscriberFragment
      brand {
        ...brandFragment
      }
      user {
        ...userFragment
      }
    }
    success
    message
    errors
  }
}
    ${NewsletterSubscriberFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type UnsubscribeNewsletterMutationFn = Apollo.MutationFunction<UnsubscribeNewsletterMutation, UnsubscribeNewsletterMutationVariables>;

/**
 * __useUnsubscribeNewsletterMutation__
 *
 * To run a mutation, you first call `useUnsubscribeNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeNewsletterMutation, { data, loading, error }] = useUnsubscribeNewsletterMutation({
 *   variables: {
 *      brandUuid: // value for 'brandUuid'
 *   },
 * });
 */
export function useUnsubscribeNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeNewsletterMutation, UnsubscribeNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeNewsletterMutation, UnsubscribeNewsletterMutationVariables>(UnsubscribeNewsletterDocument, options);
      }
export type UnsubscribeNewsletterMutationHookResult = ReturnType<typeof useUnsubscribeNewsletterMutation>;
export type UnsubscribeNewsletterMutationResult = Apollo.MutationResult<UnsubscribeNewsletterMutation>;
export type UnsubscribeNewsletterMutationOptions = Apollo.BaseMutationOptions<UnsubscribeNewsletterMutation, UnsubscribeNewsletterMutationVariables>;
export const UnsubscribeNewsletterByTokenDocument = gql`
    mutation unsubscribeNewsletterByToken($token: String!) {
  unsubscribeNewsletterByToken(input: {token: $token}) {
    success
    message
    errors
  }
}
    `;
export type UnsubscribeNewsletterByTokenMutationFn = Apollo.MutationFunction<UnsubscribeNewsletterByTokenMutation, UnsubscribeNewsletterByTokenMutationVariables>;

/**
 * __useUnsubscribeNewsletterByTokenMutation__
 *
 * To run a mutation, you first call `useUnsubscribeNewsletterByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeNewsletterByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeNewsletterByTokenMutation, { data, loading, error }] = useUnsubscribeNewsletterByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUnsubscribeNewsletterByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeNewsletterByTokenMutation, UnsubscribeNewsletterByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeNewsletterByTokenMutation, UnsubscribeNewsletterByTokenMutationVariables>(UnsubscribeNewsletterByTokenDocument, options);
      }
export type UnsubscribeNewsletterByTokenMutationHookResult = ReturnType<typeof useUnsubscribeNewsletterByTokenMutation>;
export type UnsubscribeNewsletterByTokenMutationResult = Apollo.MutationResult<UnsubscribeNewsletterByTokenMutation>;
export type UnsubscribeNewsletterByTokenMutationOptions = Apollo.BaseMutationOptions<UnsubscribeNewsletterByTokenMutation, UnsubscribeNewsletterByTokenMutationVariables>;
export const AddItemDocument = gql`
    mutation addItem($orderUuid: ID!, $listingUuid: ID!) {
  addItem(input: {orderUuid: $orderUuid, listingUuid: $listingUuid}) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    error
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type AddItemMutationFn = Apollo.MutationFunction<AddItemMutation, AddItemMutationVariables>;

/**
 * __useAddItemMutation__
 *
 * To run a mutation, you first call `useAddItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMutation, { data, loading, error }] = useAddItemMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      listingUuid: // value for 'listingUuid'
 *   },
 * });
 */
export function useAddItemMutation(baseOptions?: Apollo.MutationHookOptions<AddItemMutation, AddItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemMutation, AddItemMutationVariables>(AddItemDocument, options);
      }
export type AddItemMutationHookResult = ReturnType<typeof useAddItemMutation>;
export type AddItemMutationResult = Apollo.MutationResult<AddItemMutation>;
export type AddItemMutationOptions = Apollo.BaseMutationOptions<AddItemMutation, AddItemMutationVariables>;
export const ConfirmDocument = gql`
    mutation confirm($orderUuid: ID!, $shippingAddressAttributes: ShippingAddressAttributes!, $paymentAttributes: PaymentAttributes, $paymentMethod: PaymentMethod, $amazonCheckoutSessionId: String, $attribution: OrderAttributionAttributes) {
  confirm(
    input: {orderUuid: $orderUuid, shippingAddressAttributes: $shippingAddressAttributes, paymentAttributes: $paymentAttributes, paymentMethod: $paymentMethod, amazonCheckoutSessionId: $amazonCheckoutSessionId, attribution: $attribution}
  ) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    error
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type ConfirmMutationFn = Apollo.MutationFunction<ConfirmMutation, ConfirmMutationVariables>;

/**
 * __useConfirmMutation__
 *
 * To run a mutation, you first call `useConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMutation, { data, loading, error }] = useConfirmMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      shippingAddressAttributes: // value for 'shippingAddressAttributes'
 *      paymentAttributes: // value for 'paymentAttributes'
 *      paymentMethod: // value for 'paymentMethod'
 *      amazonCheckoutSessionId: // value for 'amazonCheckoutSessionId'
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMutation, ConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMutation, ConfirmMutationVariables>(ConfirmDocument, options);
      }
export type ConfirmMutationHookResult = ReturnType<typeof useConfirmMutation>;
export type ConfirmMutationResult = Apollo.MutationResult<ConfirmMutation>;
export type ConfirmMutationOptions = Apollo.BaseMutationOptions<ConfirmMutation, ConfirmMutationVariables>;
export const GuestCheckoutDocument = gql`
    mutation guestCheckout($orderUuid: ID!, $paymentMethod: PaymentMethod) {
  guestCheckout(input: {orderUuid: $orderUuid, paymentMethod: $paymentMethod}) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    redirectUrl
    error
    success
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type GuestCheckoutMutationFn = Apollo.MutationFunction<GuestCheckoutMutation, GuestCheckoutMutationVariables>;

/**
 * __useGuestCheckoutMutation__
 *
 * To run a mutation, you first call `useGuestCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestCheckoutMutation, { data, loading, error }] = useGuestCheckoutMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useGuestCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<GuestCheckoutMutation, GuestCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestCheckoutMutation, GuestCheckoutMutationVariables>(GuestCheckoutDocument, options);
      }
export type GuestCheckoutMutationHookResult = ReturnType<typeof useGuestCheckoutMutation>;
export type GuestCheckoutMutationResult = Apollo.MutationResult<GuestCheckoutMutation>;
export type GuestCheckoutMutationOptions = Apollo.BaseMutationOptions<GuestCheckoutMutation, GuestCheckoutMutationVariables>;
export const GuestConfirmDocument = gql`
    mutation guestConfirm($orderUuid: ID!, $guestEmail: String!, $guestTel: String!, $shippingAddressAttributes: ShippingAddressAttributes!, $paymentAttributes: PaymentAttributes, $paymentMethod: PaymentMethod, $amazonCheckoutSessionId: String, $attribution: OrderAttributionAttributes) {
  guestConfirm(
    input: {orderUuid: $orderUuid, guestEmail: $guestEmail, guestTel: $guestTel, shippingAddressAttributes: $shippingAddressAttributes, paymentAttributes: $paymentAttributes, paymentMethod: $paymentMethod, amazonCheckoutSessionId: $amazonCheckoutSessionId, attribution: $attribution}
  ) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    error
    success
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type GuestConfirmMutationFn = Apollo.MutationFunction<GuestConfirmMutation, GuestConfirmMutationVariables>;

/**
 * __useGuestConfirmMutation__
 *
 * To run a mutation, you first call `useGuestConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestConfirmMutation, { data, loading, error }] = useGuestConfirmMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      guestEmail: // value for 'guestEmail'
 *      guestTel: // value for 'guestTel'
 *      shippingAddressAttributes: // value for 'shippingAddressAttributes'
 *      paymentAttributes: // value for 'paymentAttributes'
 *      paymentMethod: // value for 'paymentMethod'
 *      amazonCheckoutSessionId: // value for 'amazonCheckoutSessionId'
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useGuestConfirmMutation(baseOptions?: Apollo.MutationHookOptions<GuestConfirmMutation, GuestConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestConfirmMutation, GuestConfirmMutationVariables>(GuestConfirmDocument, options);
      }
export type GuestConfirmMutationHookResult = ReturnType<typeof useGuestConfirmMutation>;
export type GuestConfirmMutationResult = Apollo.MutationResult<GuestConfirmMutation>;
export type GuestConfirmMutationOptions = Apollo.BaseMutationOptions<GuestConfirmMutation, GuestConfirmMutationVariables>;
export const OrderDocument = gql`
    mutation order($orderUuid: ID!, $paymentMethod: PaymentMethod) {
  order(input: {orderUuid: $orderUuid, paymentMethod: $paymentMethod}) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    redirectUrl
    error
    requiresCardReregistration
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type OrderMutationFn = Apollo.MutationFunction<OrderMutation, OrderMutationVariables>;

/**
 * __useOrderMutation__
 *
 * To run a mutation, you first call `useOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMutation, { data, loading, error }] = useOrderMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useOrderMutation(baseOptions?: Apollo.MutationHookOptions<OrderMutation, OrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderMutation, OrderMutationVariables>(OrderDocument, options);
      }
export type OrderMutationHookResult = ReturnType<typeof useOrderMutation>;
export type OrderMutationResult = Apollo.MutationResult<OrderMutation>;
export type OrderMutationOptions = Apollo.BaseMutationOptions<OrderMutation, OrderMutationVariables>;
export const RemoveItemDocument = gql`
    mutation removeItem($orderUuid: ID!, $listingUuid: ID!) {
  removeItem(input: {orderUuid: $orderUuid, listingUuid: $listingUuid}) {
    order {
      ...orderFragment
      items {
        ...itemFragment
      }
    }
    error
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;
export type RemoveItemMutationFn = Apollo.MutationFunction<RemoveItemMutation, RemoveItemMutationVariables>;

/**
 * __useRemoveItemMutation__
 *
 * To run a mutation, you first call `useRemoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemMutation, { data, loading, error }] = useRemoveItemMutation({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      listingUuid: // value for 'listingUuid'
 *   },
 * });
 */
export function useRemoveItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemMutation, RemoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemMutation, RemoveItemMutationVariables>(RemoveItemDocument, options);
      }
export type RemoveItemMutationHookResult = ReturnType<typeof useRemoveItemMutation>;
export type RemoveItemMutationResult = Apollo.MutationResult<RemoveItemMutation>;
export type RemoveItemMutationOptions = Apollo.BaseMutationOptions<RemoveItemMutation, RemoveItemMutationVariables>;
export const DeletePaymentDocument = gql`
    mutation DeletePayment($uuid: String!) {
  deletePayment(input: {uuid: $uuid}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type DeletePaymentMutationFn = Apollo.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = Apollo.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($paymentAttributes: PaymentAttributes!, $returnUrl: String) {
  updatePayment(
    input: {paymentAttributes: $paymentAttributes, returnUrl: $returnUrl}
  ) {
    redirectUrl
    error
  }
}
    `;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      paymentAttributes: // value for 'paymentAttributes'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const CreateTradeinDocument = gql`
    mutation createTradein($subdomain: String!, $attributes: TradeinAttributes!) {
  createTradein(input: {subdomain: $subdomain, attributes: $attributes}) {
    tradein {
      ...tradeinFragment
    }
    error
  }
}
    ${TradeinFragmentFragmentDoc}`;
export type CreateTradeinMutationFn = Apollo.MutationFunction<CreateTradeinMutation, CreateTradeinMutationVariables>;

/**
 * __useCreateTradeinMutation__
 *
 * To run a mutation, you first call `useCreateTradeinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTradeinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTradeinMutation, { data, loading, error }] = useCreateTradeinMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateTradeinMutation(baseOptions?: Apollo.MutationHookOptions<CreateTradeinMutation, CreateTradeinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTradeinMutation, CreateTradeinMutationVariables>(CreateTradeinDocument, options);
      }
export type CreateTradeinMutationHookResult = ReturnType<typeof useCreateTradeinMutation>;
export type CreateTradeinMutationResult = Apollo.MutationResult<CreateTradeinMutation>;
export type CreateTradeinMutationOptions = Apollo.BaseMutationOptions<CreateTradeinMutation, CreateTradeinMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const AmazonPayCheckoutSessionInfoDocument = gql`
    query AmazonPayCheckoutSessionInfo($checkoutSessionId: String!) {
  amazonPayCheckoutSessionInfo(checkoutSessionId: $checkoutSessionId) {
    checkoutSessionId
    paymentDescriptor
    buyerName
    buyerEmail
    status
  }
}
    `;

/**
 * __useAmazonPayCheckoutSessionInfoQuery__
 *
 * To run a query within a React component, call `useAmazonPayCheckoutSessionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmazonPayCheckoutSessionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmazonPayCheckoutSessionInfoQuery({
 *   variables: {
 *      checkoutSessionId: // value for 'checkoutSessionId'
 *   },
 * });
 */
export function useAmazonPayCheckoutSessionInfoQuery(baseOptions: Apollo.QueryHookOptions<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables> & ({ variables: AmazonPayCheckoutSessionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>(AmazonPayCheckoutSessionInfoDocument, options);
      }
export function useAmazonPayCheckoutSessionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>(AmazonPayCheckoutSessionInfoDocument, options);
        }
export function useAmazonPayCheckoutSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>(AmazonPayCheckoutSessionInfoDocument, options);
        }
export type AmazonPayCheckoutSessionInfoQueryHookResult = ReturnType<typeof useAmazonPayCheckoutSessionInfoQuery>;
export type AmazonPayCheckoutSessionInfoLazyQueryHookResult = ReturnType<typeof useAmazonPayCheckoutSessionInfoLazyQuery>;
export type AmazonPayCheckoutSessionInfoSuspenseQueryHookResult = ReturnType<typeof useAmazonPayCheckoutSessionInfoSuspenseQuery>;
export type AmazonPayCheckoutSessionInfoQueryResult = Apollo.QueryResult<AmazonPayCheckoutSessionInfoQuery, AmazonPayCheckoutSessionInfoQueryVariables>;
export const BrandDocument = gql`
    query brand($uuid: ID!) {
  brand(uuid: $uuid) {
    ...brandFragment
    organization {
      ...organizationFragment
    }
    conditions {
      ...conditionFragment
    }
  }
}
    ${BrandFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}`;

/**
 * __useBrandQuery__
 *
 * To run a query within a React component, call `useBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useBrandQuery(baseOptions: Apollo.QueryHookOptions<BrandQuery, BrandQueryVariables> & ({ variables: BrandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
      }
export function useBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandQuery, BrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
        }
export function useBrandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandQuery, BrandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
        }
export type BrandQueryHookResult = ReturnType<typeof useBrandQuery>;
export type BrandLazyQueryHookResult = ReturnType<typeof useBrandLazyQuery>;
export type BrandSuspenseQueryHookResult = ReturnType<typeof useBrandSuspenseQuery>;
export type BrandQueryResult = Apollo.QueryResult<BrandQuery, BrandQueryVariables>;
export const CategoriesDocument = gql`
    query categories($brandId: ID!) {
  categories(brandId: $brandId) {
    ...categoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables> & ({ variables: CategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const EventReservationsDocument = gql`
    query eventReservations {
  eventReservations {
    ...eventReservationFragment
  }
}
    ${EventReservationFragmentFragmentDoc}`;

/**
 * __useEventReservationsQuery__
 *
 * To run a query within a React component, call `useEventReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventReservationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventReservationsQuery(baseOptions?: Apollo.QueryHookOptions<EventReservationsQuery, EventReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventReservationsQuery, EventReservationsQueryVariables>(EventReservationsDocument, options);
      }
export function useEventReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventReservationsQuery, EventReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventReservationsQuery, EventReservationsQueryVariables>(EventReservationsDocument, options);
        }
export function useEventReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventReservationsQuery, EventReservationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventReservationsQuery, EventReservationsQueryVariables>(EventReservationsDocument, options);
        }
export type EventReservationsQueryHookResult = ReturnType<typeof useEventReservationsQuery>;
export type EventReservationsLazyQueryHookResult = ReturnType<typeof useEventReservationsLazyQuery>;
export type EventReservationsSuspenseQueryHookResult = ReturnType<typeof useEventReservationsSuspenseQuery>;
export type EventReservationsQueryResult = Apollo.QueryResult<EventReservationsQuery, EventReservationsQueryVariables>;
export const ListingDocument = gql`
    query listing($uuid: ID!) {
  listing(uuid: $uuid) {
    ...listingFragment
    product {
      ...productFragment
      productMaster {
        ...productMasterFragment
        sizeGuides {
          ...sizeGuideFragment
          size {
            ...sizeFragment
          }
        }
        categories {
          ...categoryFragment
        }
      }
      images {
        ...imageFragment
      }
      color {
        ...colorFragment
      }
    }
    size {
      ...sizeFragment
    }
    condition {
      ...conditionFragment
    }
    images {
      ...imageFragment
    }
    isLiked
    likeCount
  }
}
    ${ListingFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeGuideFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}`;

/**
 * __useListingQuery__
 *
 * To run a query within a React component, call `useListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useListingQuery(baseOptions: Apollo.QueryHookOptions<ListingQuery, ListingQueryVariables> & ({ variables: ListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
      }
export function useListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingQuery, ListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
        }
export function useListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingQuery, ListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
        }
export type ListingQueryHookResult = ReturnType<typeof useListingQuery>;
export type ListingLazyQueryHookResult = ReturnType<typeof useListingLazyQuery>;
export type ListingSuspenseQueryHookResult = ReturnType<typeof useListingSuspenseQuery>;
export type ListingQueryResult = Apollo.QueryResult<ListingQuery, ListingQueryVariables>;
export const ListingsDocument = gql`
    query listings($brandId: ID!, $page: Int, $perPage: Int, $search: ListingSearch) {
  listings(brandId: $brandId, page: $page, perPage: $perPage, search: $search) {
    listings {
      ...listingFragment
      product {
        ...productFragment
        productMaster {
          ...productMasterFragment
        }
        images {
          ...imageFragment
        }
        color {
          ...colorFragment
        }
      }
      size {
        ...sizeFragment
      }
      condition {
        ...conditionFragment
      }
      images {
        ...imageFragment
      }
    }
    totalCount
    pagination {
      ...paginationFragment
    }
  }
}
    ${ListingFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useListingsQuery__
 *
 * To run a query within a React component, call `useListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListingsQuery(baseOptions: Apollo.QueryHookOptions<ListingsQuery, ListingsQueryVariables> & ({ variables: ListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsQuery, ListingsQueryVariables>(ListingsDocument, options);
      }
export function useListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsQuery, ListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsQuery, ListingsQueryVariables>(ListingsDocument, options);
        }
export function useListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingsQuery, ListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingsQuery, ListingsQueryVariables>(ListingsDocument, options);
        }
export type ListingsQueryHookResult = ReturnType<typeof useListingsQuery>;
export type ListingsLazyQueryHookResult = ReturnType<typeof useListingsLazyQuery>;
export type ListingsSuspenseQueryHookResult = ReturnType<typeof useListingsSuspenseQuery>;
export type ListingsQueryResult = Apollo.QueryResult<ListingsQuery, ListingsQueryVariables>;
export const RecommendedListingsDocument = gql`
    query recommendedListings($listingUuid: ID!, $limit: Int) {
  recommendedListings(listingUuid: $listingUuid, limit: $limit) {
    ...listingFragment
    size {
      ...sizeFragment
    }
    condition {
      ...conditionFragment
    }
    images {
      ...imageFragment
    }
    product {
      ...productFragment
      productMaster {
        ...productMasterFragment
      }
      images {
        ...imageFragment
      }
      color {
        ...colorFragment
      }
    }
  }
}
    ${ListingFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${ColorFragmentFragmentDoc}`;

/**
 * __useRecommendedListingsQuery__
 *
 * To run a query within a React component, call `useRecommendedListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedListingsQuery({
 *   variables: {
 *      listingUuid: // value for 'listingUuid'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecommendedListingsQuery(baseOptions: Apollo.QueryHookOptions<RecommendedListingsQuery, RecommendedListingsQueryVariables> & ({ variables: RecommendedListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedListingsQuery, RecommendedListingsQueryVariables>(RecommendedListingsDocument, options);
      }
export function useRecommendedListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedListingsQuery, RecommendedListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedListingsQuery, RecommendedListingsQueryVariables>(RecommendedListingsDocument, options);
        }
export function useRecommendedListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedListingsQuery, RecommendedListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedListingsQuery, RecommendedListingsQueryVariables>(RecommendedListingsDocument, options);
        }
export type RecommendedListingsQueryHookResult = ReturnType<typeof useRecommendedListingsQuery>;
export type RecommendedListingsLazyQueryHookResult = ReturnType<typeof useRecommendedListingsLazyQuery>;
export type RecommendedListingsSuspenseQueryHookResult = ReturnType<typeof useRecommendedListingsSuspenseQuery>;
export type RecommendedListingsQueryResult = Apollo.QueryResult<RecommendedListingsQuery, RecommendedListingsQueryVariables>;
export const NewsletterSubscriptionDocument = gql`
    query newsletterSubscription($brandUuid: ID!) {
  newsletterSubscription(brandUuid: $brandUuid) {
    ...newsletterSubscriberFragment
    brand {
      ...brandFragment
    }
    user {
      ...userFragment
    }
  }
}
    ${NewsletterSubscriberFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;

/**
 * __useNewsletterSubscriptionQuery__
 *
 * To run a query within a React component, call `useNewsletterSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSubscriptionQuery({
 *   variables: {
 *      brandUuid: // value for 'brandUuid'
 *   },
 * });
 */
export function useNewsletterSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables> & ({ variables: NewsletterSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
      }
export function useNewsletterSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
export type NewsletterSubscriptionQueryHookResult = ReturnType<typeof useNewsletterSubscriptionQuery>;
export type NewsletterSubscriptionLazyQueryHookResult = ReturnType<typeof useNewsletterSubscriptionLazyQuery>;
export type NewsletterSubscriptionSuspenseQueryHookResult = ReturnType<typeof useNewsletterSubscriptionSuspenseQuery>;
export type NewsletterSubscriptionQueryResult = Apollo.QueryResult<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>;
export const CompletedOrderDocument = gql`
    query completedOrder($uuid: ID!) {
  completedOrder(uuid: $uuid) {
    ...orderPurchaseFragment
    items {
      ...itemFragment
      listing {
        ...listingFragment
        product {
          ...productFragment
          color {
            ...colorFragment
          }
          productMaster {
            ...productMasterFragment
          }
        }
        size {
          ...sizeFragment
        }
        condition {
          ...conditionFragment
        }
      }
    }
  }
}
    ${OrderPurchaseFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${ListingFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}`;

/**
 * __useCompletedOrderQuery__
 *
 * To run a query within a React component, call `useCompletedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedOrderQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompletedOrderQuery(baseOptions: Apollo.QueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables> & ({ variables: CompletedOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
      }
export function useCompletedOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
        }
export function useCompletedOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
        }
export type CompletedOrderQueryHookResult = ReturnType<typeof useCompletedOrderQuery>;
export type CompletedOrderLazyQueryHookResult = ReturnType<typeof useCompletedOrderLazyQuery>;
export type CompletedOrderSuspenseQueryHookResult = ReturnType<typeof useCompletedOrderSuspenseQuery>;
export type CompletedOrderQueryResult = Apollo.QueryResult<CompletedOrderQuery, CompletedOrderQueryVariables>;
export const CurrentOrderDocument = gql`
    query currentOrder($brandUuid: ID!) {
  currentOrder(brandUuid: $brandUuid) {
    ...orderFragment
    items {
      ...itemFragment
      listing {
        ...listingFragment
        product {
          ...productFragment
          color {
            ...colorFragment
          }
          productMaster {
            ...productMasterFragment
          }
          images {
            ...imageFragment
          }
        }
        size {
          ...sizeFragment
        }
        condition {
          ...conditionFragment
        }
        images {
          ...imageFragment
        }
      }
    }
    shippingAddress {
      ...shippingAddressFragment
    }
    campaign {
      ...campaignFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${ListingFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}
${ShippingAddressFragmentFragmentDoc}
${CampaignFragmentFragmentDoc}`;

/**
 * __useCurrentOrderQuery__
 *
 * To run a query within a React component, call `useCurrentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrderQuery({
 *   variables: {
 *      brandUuid: // value for 'brandUuid'
 *   },
 * });
 */
export function useCurrentOrderQuery(baseOptions: Apollo.QueryHookOptions<CurrentOrderQuery, CurrentOrderQueryVariables> & ({ variables: CurrentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(CurrentOrderDocument, options);
      }
export function useCurrentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOrderQuery, CurrentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(CurrentOrderDocument, options);
        }
export function useCurrentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentOrderQuery, CurrentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(CurrentOrderDocument, options);
        }
export type CurrentOrderQueryHookResult = ReturnType<typeof useCurrentOrderQuery>;
export type CurrentOrderLazyQueryHookResult = ReturnType<typeof useCurrentOrderLazyQuery>;
export type CurrentOrderSuspenseQueryHookResult = ReturnType<typeof useCurrentOrderSuspenseQuery>;
export type CurrentOrderQueryResult = Apollo.QueryResult<CurrentOrderQuery, CurrentOrderQueryVariables>;
export const MyOrdersDocument = gql`
    query myOrders($page: Int, $perPage: Int, $brandId: ID) {
  myOrders(page: $page, perPage: $perPage, brandId: $brandId) {
    orders {
      ...orderFragment
      items {
        ...itemFragment
        listing {
          ...listingFragment
          product {
            ...productFragment
            productMaster {
              ...productMasterFragment
            }
            images {
              ...imageFragment
            }
            color {
              ...colorFragment
            }
          }
          size {
            ...sizeFragment
          }
          condition {
            ...conditionFragment
          }
        }
      }
    }
    pagination {
      ...paginationFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${ListingFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useMyOrdersQuery__
 *
 * To run a query within a React component, call `useMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useMyOrdersQuery(baseOptions?: Apollo.QueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
      }
export function useMyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
        }
export function useMyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
        }
export type MyOrdersQueryHookResult = ReturnType<typeof useMyOrdersQuery>;
export type MyOrdersLazyQueryHookResult = ReturnType<typeof useMyOrdersLazyQuery>;
export type MyOrdersSuspenseQueryHookResult = ReturnType<typeof useMyOrdersSuspenseQuery>;
export type MyOrdersQueryResult = Apollo.QueryResult<MyOrdersQuery, MyOrdersQueryVariables>;
export const BrandProductMasterListDocument = gql`
    query brandProductMasterList($brandId: ID!) {
  brandProductMasterList(brandId: $brandId) {
    ...productMasterFragment
  }
}
    ${ProductMasterFragmentFragmentDoc}`;

/**
 * __useBrandProductMasterListQuery__
 *
 * To run a query within a React component, call `useBrandProductMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProductMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProductMasterListQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandProductMasterListQuery(baseOptions: Apollo.QueryHookOptions<BrandProductMasterListQuery, BrandProductMasterListQueryVariables> & ({ variables: BrandProductMasterListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>(BrandProductMasterListDocument, options);
      }
export function useBrandProductMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>(BrandProductMasterListDocument, options);
        }
export function useBrandProductMasterListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>(BrandProductMasterListDocument, options);
        }
export type BrandProductMasterListQueryHookResult = ReturnType<typeof useBrandProductMasterListQuery>;
export type BrandProductMasterListLazyQueryHookResult = ReturnType<typeof useBrandProductMasterListLazyQuery>;
export type BrandProductMasterListSuspenseQueryHookResult = ReturnType<typeof useBrandProductMasterListSuspenseQuery>;
export type BrandProductMasterListQueryResult = Apollo.QueryResult<BrandProductMasterListQuery, BrandProductMasterListQueryVariables>;
export const BrandProductSearchDocument = gql`
    query brandProductSearch($brandId: ID!, $search: ProductSearch) {
  brandProductSearch(brandId: $brandId, search: $search) {
    products {
      ...productFragment
      productMaster {
        ...productMasterFragment
        sizes {
          ...sizeFragment
        }
      }
      images {
        ...imageFragment
      }
      color {
        ...colorFragment
      }
      sizes {
        ...sizeFragment
      }
    }
  }
}
    ${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ColorFragmentFragmentDoc}`;

/**
 * __useBrandProductSearchQuery__
 *
 * To run a query within a React component, call `useBrandProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandProductSearchQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBrandProductSearchQuery(baseOptions: Apollo.QueryHookOptions<BrandProductSearchQuery, BrandProductSearchQueryVariables> & ({ variables: BrandProductSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandProductSearchQuery, BrandProductSearchQueryVariables>(BrandProductSearchDocument, options);
      }
export function useBrandProductSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandProductSearchQuery, BrandProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandProductSearchQuery, BrandProductSearchQueryVariables>(BrandProductSearchDocument, options);
        }
export function useBrandProductSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandProductSearchQuery, BrandProductSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandProductSearchQuery, BrandProductSearchQueryVariables>(BrandProductSearchDocument, options);
        }
export type BrandProductSearchQueryHookResult = ReturnType<typeof useBrandProductSearchQuery>;
export type BrandProductSearchLazyQueryHookResult = ReturnType<typeof useBrandProductSearchLazyQuery>;
export type BrandProductSearchSuspenseQueryHookResult = ReturnType<typeof useBrandProductSearchSuspenseQuery>;
export type BrandProductSearchQueryResult = Apollo.QueryResult<BrandProductSearchQuery, BrandProductSearchQueryVariables>;
export const ProductDocument = gql`
    query product($uuid: ID!) {
  product(uuid: $uuid) {
    ...productFragment
    productMaster {
      ...productMasterFragment
      sizeGuides {
        ...sizeGuideFragment
        size {
          ...sizeFragment
        }
      }
      sizes {
        ...sizeFragment
      }
      categories {
        ...categoryFragment
      }
    }
    brand {
      ...brandFragment
      tradeInConditions {
        ...conditionFragment
      }
    }
    color {
      ...colorFragment
    }
    images {
      ...imageFragment
    }
    sizes {
      ...sizeFragment
    }
    listings {
      ...listingFragment
      condition {
        ...conditionFragment
      }
      images {
        ...imageFragment
      }
      size {
        ...sizeFragment
      }
    }
    salesListings {
      ...listingFragment
      condition {
        ...conditionFragment
      }
      images {
        ...imageFragment
      }
      size {
        ...sizeFragment
      }
    }
    images {
      ...imageFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeGuideFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ListingFragmentFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> & ({ variables: ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductsDocument = gql`
    query products($brandId: ID!, $page: Int, $perPage: Int, $search: ProductSearch) {
  products(brandId: $brandId, page: $page, perPage: $perPage, search: $search) {
    products {
      ...productFragment
      productMaster {
        ...productMasterFragment
        sizes {
          ...sizeFragment
        }
      }
      images {
        ...imageFragment
      }
      color {
        ...colorFragment
      }
      sizes {
        ...sizeFragment
      }
      listings {
        ...listingFragment
      }
    }
    totalCount
    pagination {
      ...paginationFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ListingFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables> & ({ variables: ProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export function useProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ListingSizesDocument = gql`
    query listingSizes($brandId: ID!) {
  listingSizes(brandId: $brandId) {
    ...sizeFragment
  }
}
    ${SizeFragmentFragmentDoc}`;

/**
 * __useListingSizesQuery__
 *
 * To run a query within a React component, call `useListingSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingSizesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useListingSizesQuery(baseOptions: Apollo.QueryHookOptions<ListingSizesQuery, ListingSizesQueryVariables> & ({ variables: ListingSizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingSizesQuery, ListingSizesQueryVariables>(ListingSizesDocument, options);
      }
export function useListingSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingSizesQuery, ListingSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingSizesQuery, ListingSizesQueryVariables>(ListingSizesDocument, options);
        }
export function useListingSizesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingSizesQuery, ListingSizesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingSizesQuery, ListingSizesQueryVariables>(ListingSizesDocument, options);
        }
export type ListingSizesQueryHookResult = ReturnType<typeof useListingSizesQuery>;
export type ListingSizesLazyQueryHookResult = ReturnType<typeof useListingSizesLazyQuery>;
export type ListingSizesSuspenseQueryHookResult = ReturnType<typeof useListingSizesSuspenseQuery>;
export type ListingSizesQueryResult = Apollo.QueryResult<ListingSizesQuery, ListingSizesQueryVariables>;
export const SizesDocument = gql`
    query sizes($uuid: ID!) {
  sizes(uuid: $uuid) {
    ...sizeFragment
  }
}
    ${SizeFragmentFragmentDoc}`;

/**
 * __useSizesQuery__
 *
 * To run a query within a React component, call `useSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSizesQuery(baseOptions: Apollo.QueryHookOptions<SizesQuery, SizesQueryVariables> & ({ variables: SizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SizesQuery, SizesQueryVariables>(SizesDocument, options);
      }
export function useSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SizesQuery, SizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SizesQuery, SizesQueryVariables>(SizesDocument, options);
        }
export function useSizesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SizesQuery, SizesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SizesQuery, SizesQueryVariables>(SizesDocument, options);
        }
export type SizesQueryHookResult = ReturnType<typeof useSizesQuery>;
export type SizesLazyQueryHookResult = ReturnType<typeof useSizesLazyQuery>;
export type SizesSuspenseQueryHookResult = ReturnType<typeof useSizesSuspenseQuery>;
export type SizesQueryResult = Apollo.QueryResult<SizesQuery, SizesQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser($page: Int, $perPage: Int, $likedPage: Int, $likedPerPage: Int) {
  currentUser {
    ...userFragment
    cartReminderSubscribed
    organization {
      ...organizationFragment
      brands {
        ...brandFragment
      }
    }
    payment {
      ...paymentFragment
    }
    addresses {
      ...addressFragment
    }
    recentViewedProducts(page: $page, perPage: $perPage) {
      ...productFragment
      productMaster {
        ...productMasterFragment
        sizes {
          ...sizeFragment
        }
      }
      salesListings {
        ...listingFragment
      }
      color {
        ...colorFragment
      }
      sizes {
        ...sizeFragment
      }
      images {
        ...imageFragment
      }
    }
    totalRecentViewedProducts
    recentViewedListings(page: $page, perPage: $perPage) {
      ...listingFragment
      product {
        ...productFragment
        productMaster {
          ...productMasterFragment
        }
        color {
          ...colorFragment
        }
        images {
          ...imageFragment
        }
      }
      size {
        ...sizeFragment
      }
      images {
        ...imageFragment
      }
      condition {
        ...conditionFragment
      }
    }
    totalRecentViewedListings
    likedListings(page: $likedPage, perPage: $likedPerPage) {
      ...listingFragment
      product {
        ...productFragment
        productMaster {
          ...productMasterFragment
        }
        color {
          ...colorFragment
        }
        images {
          ...imageFragment
        }
      }
      size {
        ...sizeFragment
      }
      images {
        ...imageFragment
      }
      condition {
        ...conditionFragment
      }
    }
    totalLikedListings
  }
}
    ${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${BrandFragmentFragmentDoc}
${PaymentFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${ProductMasterFragmentFragmentDoc}
${SizeFragmentFragmentDoc}
${ListingFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ConditionFragmentFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      likedPage: // value for 'likedPage'
 *      likedPerPage: // value for 'likedPerPage'
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;